(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[125],{

/***/ 1239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Icon; }
});

;// CONCATENATED MODULE: ./node_modules/@carbon/icon-helpers/es/index.js
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

var _excluded = ["width", "height", "viewBox"],
  _excluded2 = ["tabindex"];
/**
 * Copyright IBM Corp. 2018, 2026
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  // Reference:
  // https://github.com/IBM/carbon-components-react/issues/1392
  // https://github.com/PolymerElements/iron-iconset-svg/pull/47
  // `focusable` is a string attribute which is why we do not use a boolean here
  focusable: 'false',
  preserveAspectRatio: 'xMidYMid meet'
};

/**
 * Get supplementary HTML attributes for a given <svg> element based on existing
 * attributes.
 */
function getAttributes() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    width = _ref.width,
    height = _ref.height,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? "0 0 ".concat(width, " ").concat(height) : _ref$viewBox,
    attributes = _objectWithoutProperties(_ref, _excluded);
  var tabindex = attributes.tabindex,
    rest = _objectWithoutProperties(attributes, _excluded2);
  var iconAttributes = _objectSpread2(_objectSpread2(_objectSpread2({}, defaultAttributes), rest), {}, {
    width: width,
    height: height,
    viewBox: viewBox
  });
  if (iconAttributes['aria-label'] || iconAttributes['aria-labelledby']) {
    iconAttributes.role = 'img';

    // Reference:
    // https://allyjs.io/tutorials/focusing-in-svg.html
    if (tabindex !== undefined && tabindex !== null) {
      iconAttributes.focusable = 'true';
      iconAttributes.tabindex = tabindex;
    }
  } else {
    iconAttributes['aria-hidden'] = true;
  }
  return iconAttributes;
}

/**
 * Copyright IBM Corp. 2018, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Convert an icon descriptor to a String
 */
function es_toString(descriptor) {
  var _descriptor$elem = descriptor.elem,
    elem = _descriptor$elem === void 0 ? 'svg' : _descriptor$elem,
    _descriptor$attrs = descriptor.attrs,
    attrs = _descriptor$attrs === void 0 ? {} : _descriptor$attrs,
    _descriptor$content = descriptor.content,
    content = _descriptor$content === void 0 ? [] : _descriptor$content;
  var children = content.map(es_toString).join('');
  if (elem !== 'svg') {
    return "<".concat(elem, " ").concat(formatAttributes(attrs), ">").concat(children, "</").concat(elem, ">");
  }
  return "<".concat(elem, " ").concat(formatAttributes(getAttributes(attrs)), ">").concat(children, "</").concat(elem, ">");
}
function formatAttributes(attrs) {
  return Object.keys(attrs).reduce(function (acc, key, index) {
    var attribute = "".concat(key, "=\"").concat(attrs[key], "\"");
    if (index === 0) {
      return attribute;
    }
    return acc + ' ' + attribute;
  }, '');
}

/**
 * Copyright IBM Corp. 2018, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Convert an icon descriptor to a DOM node.
 */
function toSVG(descriptor) {
  var _descriptor$elem = descriptor.elem,
    elem = _descriptor$elem === void 0 ? 'svg' : _descriptor$elem,
    _descriptor$attrs = descriptor.attrs,
    attrs = _descriptor$attrs === void 0 ? {} : _descriptor$attrs,
    _descriptor$content = descriptor.content,
    content = _descriptor$content === void 0 ? [] : _descriptor$content;
  var node = document.createElementNS('http://www.w3.org/2000/svg', elem);
  var attributes = elem !== 'svg' ? attrs : getAttributes(attrs);
  Object.keys(attributes).forEach(function (key) {
    node.setAttribute(key, attrs[key]);
  });
  for (var i = 0; i < content.length; i++) {
    node.appendChild(toSVG(content[i]));
  }
  return node;
}



// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@carbon/icons-react/es/Icon.js
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */




/**
 * Copyright IBM Corp. 2019, 2026
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
const Icon = /*#__PURE__*/(0,react.forwardRef)(function Icon({
  className,
  children,
  tabIndex,
  xmlns = 'http://www.w3.org/2000/svg',
  preserveAspectRatio = 'xMidYMid meet',
  ...rest
}, ref) {
  const {
    tabindex,
    ...attrs
  } = getAttributes({
    ...rest,
    tabindex: tabIndex
  });
  const props = attrs;
  if (className) {
    props.className = className;
  }
  if (tabindex !== undefined && tabindex !== null) {
    if (typeof tabindex === 'number') {
      props.tabIndex = tabindex;
    } else {
      props.tabIndex = Number(tabIndex);
    }
  }
  if (ref) {
    props.ref = ref;
  }
  if (xmlns) {
    props.xmlns = xmlns;
  }
  if (preserveAspectRatio) {
    props.preserveAspectRatio = preserveAspectRatio;
  }
  return /*#__PURE__*/react.createElement('svg', props, children);
});
Icon.displayName = 'Icon';
Icon.propTypes = {
  'aria-hidden': prop_types_default().oneOfType([(prop_types_default()).bool, prop_types_default().oneOf(['true', 'false'])]),
  'aria-label': (prop_types_default()).string,
  'aria-labelledby': (prop_types_default()).string,
  children: (prop_types_default()).node,
  className: (prop_types_default()).string,
  height: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  preserveAspectRatio: (prop_types_default()).string,
  tabIndex: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  viewBox: (prop_types_default()).string,
  width: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  xmlns: (prop_types_default()).string
};




/***/ }),

/***/ 8808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dz": function() { return /* binding */ Pause; }
/* harmony export */ });
/* unused harmony exports NetworkAdminControl, NetworkEnterprise, NetworkInterface, NetworkOverlay, NetworkPublic, NetworkTimeProtocol, Network_3Reference, Network_4, Network_4Reference, NewTab, NextFilled, NextOutline, NoImage, NoTicket, Nominal, NonCertified, NoodleBowl, NotAvailable, NotSent, NotSentFilled, Notebook, NotebookReference, Notification, NotificationCounter, NotificationFilled, NotificationNew, NotificationOff, NotificationOffFilled, NotificationsPaused, NullSign, NumberSmall_0, NumberSmall_1, NumberSmall_2, NumberSmall_3, NumberSmall_4, NumberSmall_5, NumberSmall_6, NumberSmall_7, NumberSmall_8, NumberSmall_9, Number_0, Number_1, Number_2, Number_3, Number_4, Number_5, Number_6, Number_7, Number_8, Number_9, Object, ObjectStorage, ObjectStorageAlt, ObservedHail, ObservedLightning, Omega, Opacity, OpenPanelBottom, OpenPanelFilledBottom, OpenPanelFilledLeft, OpenPanelFilledRight, OpenPanelFilledTop, OpenPanelLeft, OpenPanelRight, OpenPanelTop, OperationsField, OperationsRecord, Orchestrate, OrderDetails, Ordinal, Outage, OutlookSevere, OverflowMenuHorizontal, OverflowMenuVertical, Overlay, Package, PackageNode, PackageTextAnalysis, PageBreak, PageFirst, PageLast, PageNumber, PaintBrush, PaintBrushAlt, PalmTree, PanHorizontal, PanVertical, PanelExpansion, Paragraph, Parameter, ParentChild, ParentNode, PartDefinition, PartUsage, PartitionAuto, PartitionCollection, PartitionRepartition, PartitionSame, PartitionSpecific, PartlyCloudy, PartlyCloudyNight, Partnership, PassengerDrinks, PassengerPlus, Password, Paste, PauseFilled, PauseFuture, PauseOutline, PauseOutlineFilled, PausePast, PcnENode, PcnMilitary, PcnPNode, PcnZNode, Pdf, PdfReference, Pedestrian, PedestrianFamily, QOperation, QOperationGauge, QOperationIf, WatsonHealthNominate, WatsonHealthPageScroll */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _circle4, _path7, _circle5, _circle6, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _circle7, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _circle8, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _circle9, _path103, _path104, _path105, _circle0, _path106, _path107, _circle1, _circle10, _circle11, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _circle18, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288;
const Network_3Reference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Network_3Reference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V22h8Zm-6-2h4V24H24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17H22V15h2a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10,10H2V2h8ZM4,8H8V4H4Z"
  })), children);
})));
if (false) {}
const Network_4 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Network_4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9626,3.9626,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97a3.9239,3.9239,0,0,0,0,4.7744l-3.1758,3.97A3.96,3.96,0,0,0,8,22a4,4,0,1,0,4,4,3.9624,3.9624,0,0,0-.81-2.3872l3.1758-3.97A3.9658,3.9658,0,0,0,19.8579,17h4.2842A3.9934,3.9934,0,1,0,28,12ZM6,6A2,2,0,1,1,8,8,2.0023,2.0023,0,0,1,6,6ZM8,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,28Zm8-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
})));
if (false) {}
const Network_4Reference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Network_4Reference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "26",
    r: "2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "6",
    r: "2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a3.9962,3.9962,0,0,0-3.8579,3H19.8579a3.9655,3.9655,0,0,0-5.4914-2.6426L11.19,8.3872A3.9624,3.9624,0,0,0,12,6a4,4,0,1,0-4,4,3.96,3.96,0,0,0,1.6338-.3574l3.176,3.97A3.9613,3.9613,0,0,0,12,16a3.9915,3.9915,0,0,0,7.8579,1h4.2842A3.9934,3.9934,0,1,0,28,12ZM8,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,8Zm8,10a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,16,18Zm12,0a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,28,18Z"
  })), children);
})));
if (false) {}
const NetworkAdminControl = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NetworkAdminControl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.415 25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24,4a4.0045,4.0045,0,0,0-4,4,3.951,3.951,0,0,0,.5669,2.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.18 5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"
  })), children);
})));
if (false) {}
const NetworkEnterprise = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NetworkEnterprise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10a10,10,0,0,0-19.62.124A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.377-10.9795l.8365-.0571.09-.8335A7.9934,7.9934,0,0,1,23.7368,10Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H18a2.0023,2.0023,0,0,0-2,2v4H12a2.0023,2.0023,0,0,0-2,2V30H30V14A2.0023,2.0023,0,0,0,28,12ZM12,28V20h4v8Zm16,0H18V14H28Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V20H20z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16H26V20H24z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H22V26H20z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H26V26H24z"
  })), children);
})));
if (false) {}
const NetworkOverlay = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NetworkOverlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23 13.83 23 16.41 20.41 15 19 10 24 15 29 16.41 27.59 13.83 25 22 25 22 23z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13 19.17 13 16.59 10.41 18 9 23 14 18 19 16.59 17.59 19.17 15 11 15 11 13z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), children);
})));
if (false) {}
const NetworkPublic = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NetworkPublic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S27.2,13,22.5,13z M29,21h-3c0-2-0.3-4-0.9-5.5 C27.2,16.5,28.8,18.5,29,21z M22.5,28C22.5,28,22.5,28,22.5,28c-0.4-0.2-1.3-1.8-1.5-5h2.9C23.7,26.2,22.9,27.8,22.5,28z M21,21 c0.1-3.8,1.1-5.8,1.4-6c0,0,0,0,0,0c0.4,0.2,1.4,2.2,1.5,6H21z M19.9,15.5C19.3,17,19.1,19,19,21h-3C16.2,18.5,17.8,16.5,19.9,15.5z M16.2,23H19c0.1,1.6,0.4,3.2,0.9,4.5C18.1,26.7,16.7,25,16.2,23z M25.1,27.5c0.5-1.3,0.8-2.8,0.9-4.5h2.9 C28.3,25,26.9,26.7,25.1,27.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,10c-0.9-4.6-5-8-9.8-8c-4.8,0-8.9,3.4-9.8,8.1C2.7,10.8,0,13.8,0,17.5C0,21.6,3.4,25,7.5,25H11v-2H7.5 c-3,0-5.5-2.5-5.5-5.5c0-2.9,2.2-5.3,5.1-5.5L8,12L8,11.1C8.5,7.1,11.9,4,16,4c3.7,0,6.8,2.6,7.7,6H25.8z"
  })), children);
})));
if (false) {}
const NetworkInterface = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NetworkInterface({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m28,18h-2V6h-13v-2h13c1.1028,0,2,.8972,2,2v12Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m18,28H6c-1.1028,0-2-.8972-2-2v-13h2v13h12v2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m26,21l-1.793,1.793-5.5076-5.5078c.187-.3911.3005-.8232.3005-1.2852,0-1.6543-1.3457-3-3-3-.4617,0-.894.1133-1.2852.3008l-5.2817-5.2817c.3513-.5947.5669-1.2793.5669-2.019,0-2.2056-1.7944-4-4-4S2,3.7944,2,6s1.7944,4,4,4c.7395,0,1.4241-.2153,2.019-.5669l5.2815,5.2817c-.187.3911-.3005.8232-.3005,1.2852,0,1.6543,1.3457,3,3,3,.4617,0,.894-.1133,1.2852-.3008l5.5078,5.5078-1.793,1.793,5,5,5-5-5-5ZM4,6c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2Zm11,10c0-.5513.4485-1,1-1s1,.4487,1,1-.4485,1-1,1-1-.4487-1-1Zm8.8286,10l2.1714-2.1714,2.1714,2.1714-2.1714,2.1714-2.1714-2.1714Z"
  })), children);
})));
if (false) {}
const NetworkTimeProtocol = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NetworkTimeProtocol({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,27c-.3-.9-1-1.5-1.8-1.8v-3.2c5-.5,9-4.8,9-9.9S21.5,2.1,16,2.1,6,6.5,6,12s3.9,9.5,9,10v3.2c-.9.3-1.5,1-1.8,1.8H4v2h9.2c.4,1.2,1.5,2,2.8,2s2.4-.8,2.8-2h9.2v-2h-9.2ZM8,12c0-4.4,3.6-8,8-8s8,3.6,8,8-3.6,8-8,8-8-3.6-8-8ZM16,29c-.6,0-1-.5-1-1s.4-1,1-1,1,.5,1,1-.5,1-1,1ZM19.3,16.7l-4.3-4.3v-6.4h2v5.6l3.7,3.7s-1.4,1.4-1.4,1.4Z"
  })), children);
})));
if (false) {}
const NewTab = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NewTab({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
      d: "M13,13H3V3h5V2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V8h-1V13z"
    })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
      d: "M13 3 13 1 12 1 12 3 10 3 10 4 12 4 12 6 13 6 13 4 15 4 15 3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H16V4H6A2.002,2.002,0,0,0,4,6V26a2.002,2.002,0,0,0,2,2H26a2.002,2.002,0,0,0,2-2V16H26Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6 26 6z"
  })), children);
})));
if (false) {}
const NextFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NextFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm6-1H20.15L14.57,9.3926,16,8l8,8-8,8-1.43-1.4272L20.15,17H8Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8 14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const NextOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NextOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8 14.57 9.393 20.15 15 8 15 8 17 20.15 17 14.57 22.573 16 24 24 16 16 8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const NoImage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NoImage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H26a2.0027,2.0027,0,0,0,2-2V5.4141ZM26,26H7.4141l7.7929-7.793,2.3788,2.3787a2,2,0,0,0,2.8284,0L22,19l4,3.9973Zm0-5.8318-2.5858-2.5859a2,2,0,0,0-2.8284,0L19,19.1682l-2.377-2.3771L26,7.4141Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6,22V19l5-4.9966,1.3733,1.3733,1.4159-1.416-1.375-1.375a2,2,0,0,0-2.8284,0L6,16.1716V6H22V4H6A2.002,2.002,0,0,0,4,6V22Z"
  })), children);
})));
if (false) {}
const NoTicket = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NoTicket({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6h-.5859L30,3.4141,28.5859,2,2,28.5859,3.4141,30l4-4H28a2.0027,2.0027,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4,1,1,0,0,0,1-1V8A2.0023,2.0023,0,0,0,28,6Zm0,6.1265a4,4,0,0,0,0,7.7465V24H21V21H19v3H9.4141L19,14.4141V19h2V12.4141L25.4141,8H28Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4,12.1265V8H19V6H4A2.0023,2.0023,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5H4V19.873a4,4,0,0,0,0-7.7465Z"
  })), children);
})));
if (false) {}
const Nominal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Nominal({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
      d: "M12,8 C13.6568542,8 15,9.34314575 15,11 C15,12.6568542 13.6568542,14 12,14 C10.3431458,14 9,12.6568542 9,11 C9,9.34314575 10.3431458,8 12,8 Z M4,8 C5.65685425,8 7,9.34314575 7,11 C7,12.6568542 5.65685425,14 4,14 C2.34314575,14 1,12.6568542 1,11 C1,9.34314575 2.34314575,8 4,8 Z M12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 Z M4,9 C2.8954305,9 2,9.8954305 2,11 C2,12.1045695 2.8954305,13 4,13 C5.1045695,13 6,12.1045695 6,11 C6,9.8954305 5.1045695,9 4,9 Z M8,2 C9.65685425,2 11,3.34314575 11,5 C11,6.65685425 9.65685425,8 8,8 C6.34314575,8 5,6.65685425 5,5 C5,3.34314575 6.34314575,2 8,2 Z M8,3 C6.8954305,3 6,3.8954305 6,5 C6,6.1045695 6.8954305,7 8,7 C9.1045695,7 10,6.1045695 10,5 C10,3.8954305 9.1045695,3 8,3 Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24,28a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,28Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,18Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,8,28ZM8,18a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,8,18Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,16,14ZM16,4a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const WatsonHealthNominate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthNominate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H19a3,3,0,0,0-3,3v2h2V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V26A3,3,0,0,0,25,23Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18a4,4,0,1,0,4-4A4,4,0,0,0,18,18Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,24,18Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.59 7.41 16 6 17.41 10 21.41 17 14.41 15.59 13 10 18.59z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), children);
})));
if (false) {}
const NonCertified = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NonCertified({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H16V10H6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H14V14H6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H10V18H6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H7.4141L30,3.4141,28.5859,2l-2,2H4A2.0023,2.0023,0,0,0,2,6V22H4V6H24.5859L2,28.5859,3.4141,30l2-2H28a2.0023,2.0023,0,0,0,2-2V10H28Z"
  })), children);
})));
if (false) {}
const NoodleBowl = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NoodleBowl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4141,15l-8-8L2,8.4141,8.5859,15H2v1a14,14,0,0,0,28,0V15ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8a5.0049,5.0049,0,0,0-1.5708.2554A8.0242,8.0242,0,0,0,14,5,7.9364,7.9364,0,0,0,9.0938,6.68L4.4141,2,3,3.4141,9.05,9.4648l.707-.7075A5.96,5.96,0,0,1,14,7a6.02,6.02,0,0,1,4.6875,2.2642,5.06,5.06,0,0,0-.59.61A2.9892,2.9892,0,0,1,15.7544,11H12v2h3.7544a4.98,4.98,0,0,0,3.9033-1.8745A3,3,0,0,1,25,13h2A5.0059,5.0059,0,0,0,22,8Z"
  })), children);
})));
if (false) {}
const NotAvailable = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotAvailable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H14V17H4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15H28V17H18z"
  })), children);
})));
if (false) {}
const NotSent = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotSent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.59,3.41,2,2,3.41l8,8L2.66,14.06a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,17,30h0a1,1,0,0,0,.92-.66L20.6,22l8,8ZM5.8,15,11.54,13l3.05,3-1.83,1.83ZM17,26.2l-2.79-7L16,17.41l3,3.05Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15.69,11.45l7.64-2.78-2.78,7.64,1.56,1.56L25.94,7.34a1,1,0,0,0-1.28-1.28L14.13,9.89Z"
  })), children);
})));
if (false) {}
const NotSentFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotSentFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.59,3.41,2,2,3.41l8,8L2.66,14.06a1,1,0,0,0,0,1.87l8.59,3.43L14.59,16,16,17.41l-3.37,3.37,3.44,8.59A1,1,0,0,0,17,30h0a1,1,0,0,0,.92-.66L20.6,22l8,8Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49,16.83l3.45-9.49a1,1,0,0,0-1.28-1.28L15.17,9.51Z"
  })), children);
})));
if (false) {}
const Notebook = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Notebook({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H26V17H19z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H26V22H19z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
  })), children);
})));
if (false) {}
const NotebookReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotebookReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H26V17H19z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H26V22H19z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
  })), children);
})));
if (false) {}
const Notification = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Notification({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
      d: "M14.4,10.1L13,8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4V12 c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0h3.5C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5 C14.5,10.4,14.4,10.2,14.4,10.1z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5h-11v-0.8l1.3-1.4 C3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4s4,1.8,4,4V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z"
  })), children);
})));
if (false) {}
const NotificationFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotificationFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), children);
})));
if (false) {}
const NotificationNew = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotificationNew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "8",
    r: "4"
  })), children);
})));
if (false) {}
const NotificationOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotificationOff({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
      d: "M2.5,11.5v-0.8l1.3-1.4C3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4c0.9,0,1.8,0.3,2.5,0.9l0.7-0.7C10.5,2,9.5,1.6,8.5,1.5v-1h-1 v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4v1H2.5z"
    })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
      d: "M13,8.8V6.5c0-0.8-0.2-1.6-0.5-2.2L15,1.7L14.3,1L1,14.3L1.7,15l2.5-2.5h1.3C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14 c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5c0-0.1-0.1-0.3-0.1-0.4L13,8.8z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5H5.2L11.7,5C11.9,5.5,12,6,12,6.5V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.5859V13a9.9217,9.9217,0,0,0-1.0833-4.5024L30,3.4141,28.5859,2,2,28.5859,3.4141,30l6-6H11v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H11.4141L23.4119,10.0024A7.949,7.949,0,0,1,24,13v4a1,1,0,0,0,.293.707L27,20.4141Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M7.707,17.707A1,1,0,0,0,8,17V13a8.0092,8.0092,0,0,1,8-8,7.9253,7.9253,0,0,1,4.9857,1.7681l1.4264-1.4263A9.934,9.934,0,0,0,17,3.0508V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859l-3,3L4.4141,21Z"
  })), children);
})));
if (false) {}
const NotificationOffFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotificationOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.5859V13a9.8828,9.8828,0,0,0-1.0869-4.499L30,3.4141,28.5859,2,2,28.5859,3.4141,30l6-6H11v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a.9993.9993,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M21.61,4.7383A9.9256,9.9256,0,0,0,17,3.0508V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a.9738.9738,0,0,0,.0585.29Z"
  })), children);
})));
if (false) {}
const NotificationCounter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotificationCounter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,12v15H5V5h15v-2H5c-1.1046,0-2,.8954-2,2v22c0,1.1046.8954,2,2,2h22c1.1046,0,2-.8954,2-2v-15h-2Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "26.5",
    cy: "5.5",
    r: "3.5",
    strokeWidth: "0"
  })), children);
})));
if (false) {}
const NotificationsPaused = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NotificationsPaused({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M29,5l-3.625,4h3.625v2h-6v-2l3.75-4h-3.75v-2h6v2ZM28.707,19.293c.1875.1875.293.4419.293.707v3c0,.5522-.4473,1-1,1h-7v1c0,2.7568-2.2432,5-5,5s-5-2.2432-5-5v-1h-7c-.5527,0-1-.4478-1-1v-3c0-.2651.1055-.5195.293-.707l2.707-2.707v-3.5859c0-5.1763,3.9541-9.4458,9-9.9492V1h2v2.0508c1.0583.1055,2.0641.3853,3,.7959v2.1533c-1.1783-.6841-2.5422-1-4-1-4.4111,0-8,3.5889-8,8v4c0,.2651-.1055.5195-.293.707l-2.707,2.707v1.586h22v-1.586l-2.707-2.707c-.1875-.1875-.293-.4419-.293-.707v-3h2v2.5859l2.707,2.707h0ZM19,24h-6v1c0,1.6543,1.3457,3,3,3s3-1.3457,3-3v-1Z"
  })), children);
})));
if (false) {}
const NullSign = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NullSign({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4142l-1.4142-1.4142-3.4317,3.4317c-2.4572-2.1313-5.6536-3.4317-9.1541-3.4317-7.7197,0-14,6.2803-14,14,0,3.5005,1.3004,6.6969,3.4317,9.1541l-3.4317,3.4317,1.4142,1.4142,3.4317-3.4317c2.4572,2.1313,5.6536,3.4317,9.1541,3.4317,7.7197,0,14-6.2803,14-14,0-3.5005-1.3004-6.6969-3.4317-9.1541,0,0,3.4317-3.4317,3.4317-3.4317ZM4,16c0-6.6167,5.3833-12,12-12,2.9492,0,5.649,1.0739,7.7406,2.8452L6.8452,23.7406c-1.7713-2.0916-2.8452-4.7914-2.8452-7.7406ZM28,16c0,6.6172-5.3828,12-12,12-2.9491,0-5.6489-1.074-7.7405-2.8453L25.1547,8.2595c1.7713,2.0916,2.8453,4.7914,2.8453,7.7405Z"
  })), children);
})));
if (false) {}
const Number_0 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_0({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H17V17H15z"
  })), children);
})));
if (false) {}
const Number_1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
  })), children);
})));
if (false) {}
const Number_2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
  })), children);
})));
if (false) {}
const Number_3 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
  })), children);
})));
if (false) {}
const Number_4 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
  })), children);
})));
if (false) {}
const Number_5 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_5({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), children);
})));
if (false) {}
const Number_6 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_6({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
  })), children);
})));
if (false) {}
const Number_7 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_7({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9 12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
  })), children);
})));
if (false) {}
const Number_8 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_8({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
  })), children);
})));
if (false) {}
const Number_9 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Number_9({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
  })), children);
})));
if (false) {}
const NumberSmall_0 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_0({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
  })), children);
})));
if (false) {}
const NumberSmall_1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19 17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
})));
if (false) {}
const NumberSmall_2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
  })), children);
})));
if (false) {}
const NumberSmall_3 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
  })), children);
})));
if (false) {}
const NumberSmall_4 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11 17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
  })), children);
})));
if (false) {}
const NumberSmall_5 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_5({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
  })), children);
})));
if (false) {}
const NumberSmall_6 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_6({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
  })), children);
})));
if (false) {}
const NumberSmall_7 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_7({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 21 14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
  })), children);
})));
if (false) {}
const NumberSmall_8 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_8({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
  })), children);
})));
if (false) {}
const NumberSmall_9 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NumberSmall_9({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
  })), children);
})));
if (false) {}
const Object$1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Object({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M6,3h4v2h-4v8c0,1.2002-.5425,2.2661-1.3823,3,.8398.7339,1.3823,1.7998,1.3823,3v8h4v2h-4c-1.103,0-2-.8975-2-2v-8c0-1.1025-.897-2-2-2v-2c1.103,0,2-.8975,2-2V5c0-1.1025.897-2,2-2ZM28,13V5c0-1.1025-.897-2-2-2h-4v2h4v8c0,1.2002.5425,2.2661,1.3823,3-.8398.7339-1.3823,1.7998-1.3823,3v8h-4v2h4c1.103,0,2-.8975,2-2v-8c0-1.1025.897-2,2-2v-2c-1.103,0-2-.8975-2-2Z"
  })), children);
})));
if (false) {}
const ObjectStorage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ObjectStorage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8H22v6H16v8h8V16h6ZM22,20H18V16h4Zm6-6H24V10h4Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10H10V2h8ZM12,8h4V4H12Z"
  })), children);
})));
if (false) {}
const ObjectStorageAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ObjectStorageAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
  })), children);
})));
if (false) {}
const ObservedHail = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ObservedHail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "23.5",
    r: "1.5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "19.5",
    r: "1.5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "19.5",
    r: "1.5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M11.964 14.5H17.036V16.499H11.964z",
    transform: "rotate(-45 14.5 15.5)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M17.964 14.5H23.035999999999998V16.499H17.964z",
    transform: "rotate(-45 20.5 15.5)"
  })), children);
})));
if (false) {}
const ObservedLightning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ObservedLightning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 24 13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
})));
if (false) {}
const Omega = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Omega({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
  })), children);
})));
if (false) {}
const Opacity = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Opacity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V10H6z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H14V14H10z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H18V10H14z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H26V10H22z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H10V18H6z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H18V18H14z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H26V18H22z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H18V26H14z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H26V26H22z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H22V14H18z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14V22H10z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V22H18z"
  })), children);
})));
if (false) {}
const OpenPanelBottom = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OpenPanelBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
  })), children);
})));
if (false) {}
const OpenPanelFilledBottom = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OpenPanelFilledBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
  })), children);
})));
if (false) {}
const OpenPanelFilledLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OpenPanelFilledLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
  })), children);
})));
if (false) {}
const OpenPanelFilledRight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OpenPanelFilledRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
  })), children);
})));
if (false) {}
const OpenPanelFilledTop = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OpenPanelFilledTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
  })), children);
})));
if (false) {}
const OpenPanelLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OpenPanelLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
  })), children);
})));
if (false) {}
const OpenPanelRight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OpenPanelRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
  })), children);
})));
if (false) {}
const OpenPanelTop = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OpenPanelTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
  })), children);
})));
if (false) {}
const QOperation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QOperation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26 21 26 26 16 21 6 23 6 28 16 23 26z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H6V26H4z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9H12a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,16,9Zm0,12H12V11h4Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H15V17H13z"
  })), children);
})));
if (false) {}
const QOperationGauge = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QOperationGauge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4 24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17.62,22.08,14l-1.73-1-2.18,3.76A12,12,0,0,0,2,28H4a10,10,0,0,1,13.16-9.48L14,24a2,2,0,1,0,2,2,2,2,0,0,0-.27-1L19,19.35A10,10,0,0,1,24,28h2A12,12,0,0,0,20,17.62Z"
  })), children);
})));
if (false) {}
const QOperationIf = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QOperationIf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H14V23H12z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9H14V11H12z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11V9H20a2,2,0,0,0-2,2v2H16v2h2v8h2V15h3V13H20V11Z"
  })), children);
})));
if (false) {}
const OperationsField = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OperationsField({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H26V8H16z",
    transform: "rotate(-90 21 7)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H30V8H20z",
    transform: "rotate(-90 25 7)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H34V8H24z",
    transform: "rotate(-90 29 7)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
  })), children);
})));
if (false) {}
const OperationsRecord = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OperationsRecord({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H30V22H20z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H30V26H20z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28H30V30H20z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4,3.9123,3.9123,0,0,1,4,4h2a6,6,0,1,0-6,6Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
  })), children);
})));
if (false) {}
const Orchestrate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Orchestrate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20c-.9421,0-1.7739.4453-2.3243,1.1266l-14.4392-5.0535,14.3519-4.3056c.5466.7434,1.4202,1.2324,2.4116,1.2324,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.6034,0-2.9057,1.2674-2.985,2.8514l-14.1704,4.2511,5.1461-6.2897c.3169.1141.6535.1872,1.0093.1872,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3-3,1.3457-3,3c0,.5677.1675,1.0934.4426,1.5466l-5.4332,6.6406c-.3169-.1141-.6536-.1871-1.0094-.1871-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c.3558,0,.6924-.073,1.0094-.1872l5.4333,6.6404c-.2751.4532-.4427.9789-.4427,1.5468,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3c-.3559,0-.6926.073-1.0096.1873l-4.9651-6.0688,13.9758,4.8918c.0056,1.6495,1.3481,2.9898,2.999,2.9898,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3h0ZM26,9c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1ZM15,4c.5513,0,1,.4487,1,1s-.4487,1-1,1-1-.4487-1-1,.4487-1,1-1ZM16,27c0,.5518-.4487,1-1,1s-1-.4482-1-1,.4487-1,1-1,1,.4482,1,1ZM5,16c0-.5513.4487-1,1-1s1,.4487,1,1-.4487,1-1,1-1-.4487-1-1ZM26,24c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1Z"
  })), children);
})));
if (false) {}
const OrderDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OrderDetails({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21H13a3,3,0,0,0-3,3v2h2V24a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V24A3,3,0,0,0,19,21Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
})));
if (false) {}
const Ordinal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Ordinal({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
      d: "M1,13 L1,12 L3,12 L3,9 L5.999,9 L6,6 L9,6 L9,3 L13,3 L13,12 L15,12 L15,13 L1,13 Z M5.999,10 L4,10 L4,12 L5.999,12 L5.999,10 Z M8.999,7 L6.999,7 L6.999,9 L7,9 L7,12 L8.999,12 L8.999,7 Z M12,4 L10,4 L10,12 L12,12 L12,4 Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z"
  })), children);
})));
if (false) {}
const Outage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Outage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H21V26H12z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7832,18.9746l1.4177-1.418A6.9206,6.9206,0,0,1,8,12,7.99,7.99,0,0,1,21.5273,6.2305l1.4136-1.4136A9.9884,9.9884,0,0,0,6,12,8.9411,8.9411,0,0,0,8.7832,18.9746Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,2,28.5859,3.4141,30,23.6606,9.7534A7.7069,7.7069,0,0,1,24,12a7.2032,7.2032,0,0,1-2.8223,6.1426C20.1069,19.1348,19,20.1611,19,22h2c0-.9194.5264-1.45,1.5352-2.3857A9.193,9.193,0,0,0,26,12a9.8739,9.8739,0,0,0-.7764-3.81Z"
  })), children);
})));
if (false) {}
const OutlookSevere = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OutlookSevere({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
  })), children);
})));
if (false) {}
const OverflowMenuHorizontal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OverflowMenuHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "16",
    r: "2"
  })), children);
})));
if (false) {}
const OverflowMenuVertical = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function OverflowMenuVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "8",
    r: "2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), children);
})));
if (false) {}
const Overlay = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Overlay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
  })), children);
})));
if (false) {}
const Package = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Package({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H19V22H13z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 8.59 17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
  })), children);
})));
if (false) {}
const PackageTextAnalysis = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PackageTextAnalysis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22H19V24H13z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m2,18v2h2v8c0,1.1025.8972,2,2,2h20c1.1028,0,2-.8975,2-2v-8h2v-2H2Zm24,10H6v-8h20v8Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m29,16h-5c-1.1025,0-2-.8975-2-2v-6c0-1.103.8975-2,2-2h5v2h-5v6h5v2Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m18,6h-4v-4h-2v14h6c1.1025,0,2-.8975,2-2v-6c0-1.103-.8975-2-2-2Zm-4,8v-6h4v6h-4Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m8,6H3v2h5v2h-4c-1.1046,0-2,.8954-2,2v2c0,1.1046.8954,2,2,2h6V8c0-1.103-.8975-2-2-2Zm0,8h-4v-2h4v2Z"
  })), children);
})));
if (false) {}
const PackageNode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PackageNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,28H4c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h10c1.1028,0,2,.8972,2,2v4h12c1.1028,0,2,.8972,2,2v14c0,1.1028-.8972,2-2,2ZM4,12v14h24v-14H4Zm0-2h10v-4H4v4Z"
  })), children);
})));
if (false) {}
const PageFirst = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PageFirst({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16 24 6 25.4 7.4 16.8 16 25.4 24.6 24 26z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H10V28H8z"
  })), children);
})));
if (false) {}
const PageLast = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PageLast({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16 8 26 6.6 24.6 15.2 16 6.6 7.4 8 6z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H24V28H22z"
  })), children);
})));
if (false) {}
const PageBreak = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PageBreak({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H30V20H26z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M24,22v6H8V22H6v6a2.0058,2.0058,0,0,0,2,2H24a2.0058,2.0058,0,0,0,2-2V22Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M8,16V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V16ZM18,4.4,23.6,10H18Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14V20H10z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V20H18z"
  })), children);
})));
if (false) {}
const PageNumber = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PageNumber({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26 16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
})));
if (false) {}
const WatsonHealthPageScroll = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthPageScroll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H24V6H16V4h8a1.89,1.89,0,0,1,2,2Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17 24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
  })), children);
})));
if (false) {}
const PaintBrush = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PaintBrush({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
  })), children);
})));
if (false) {}
const PaintBrushAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PaintBrushAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), children);
})));
if (false) {}
const PalmTree = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PalmTree({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
  })), children);
})));
if (false) {}
const PanHorizontal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PanHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10 22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
  })), children);
})));
if (false) {}
const PanVertical = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PanVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8 11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
  })), children);
})));
if (false) {}
const PanelExpansion = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PanelExpansion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6H6A2,2,0,0,0,4,8v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V8A2,2,0,0,0,12,6ZM6,14V8h6v6Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V8A2,2,0,0,0,26,6ZM20,24V8h6V24Z"
  })), children);
})));
if (false) {}
const Paragraph = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Paragraph({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
  })), children);
})));
if (false) {}
const Parameter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Parameter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
  })), children);
})));
if (false) {}
const ParentChild = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ParentChild({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
  })), children);
})));
if (false) {}
const ParentNode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ParentNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20c-2.41,0-4.43,1.72-4.9,4h-4.1c-2.21,0-4-1.79-4-4v-8.1c2.28-.46,4-2.48,4-4.9,0-2.76-2.24-5-5-5s-5,2.24-5,5c0,2.41,1.72,4.43,4,4.9v8.1c0,3.31,2.69,6,6,6h4.1c.46,2.28,2.48,4,4.9,4,2.76,0,5-2.24,5-5s-2.24-5-5-5ZM23,28c-1.65,0-3-1.35-3-3s1.35-3,3-3,3,1.35,3,3-1.35,3-3,3Z"
  })), children);
})));
if (false) {}
const PartDefinition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20.8336,16.8081c-2.4408,0-3.8336.9114-3.8336,2.7507,0,1.5986,1.0315,2.6477,2.854,2.6477,1.3408,0,2.321-.6019,2.613-1.7539h.1034c.1371.9285.7216,1.5474,1.6675,1.5474h1.2203v-1.7534h-.8938v-4.2292c0-2.0459-1.2891-3.1979-3.7133-3.1979-1.8052,0-2.8539.6879-3.5073,1.7194l1.3068,1.1689c.4296-.6189,1.0144-1.1344,2.0454-1.1344,1.1694,0,1.668.5844,1.668,1.5817v.6531h-1.5304Zm1.5304,2.51c0,.8425-.7908,1.2893-1.7705,1.2893-.8601,0-1.3586-.3608-1.3586-1.0833v-.292c0-.7048.5679-1.1002,1.7194-1.1002h1.4098v1.1862Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9.272,17.427h3.1287c2.218,0,3.5588-1.4785,3.5588-3.7133,0-2.2181-1.3408-3.7137-3.5588-3.7137h-5.3981v12h2.2694v-4.573Zm0-5.4501h2.9225c.8767,0,1.4098.4642,1.4098,1.3414v.7908c0,.8767-.5331,1.358-1.4098,1.358h-2.9225v-3.4902Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), children);
})));
if (false) {}
const PartUsage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20.8336,16.8081c-2.4408,0-3.8336.9114-3.8336,2.7507,0,1.5986,1.0315,2.6477,2.854,2.6477,1.3408,0,2.321-.6019,2.613-1.7539h.1034c.1371.9285.7216,1.5474,1.6675,1.5474h1.2203v-1.7534h-.8938v-4.2292c0-2.0459-1.2891-3.1979-3.7133-3.1979-1.8052,0-2.8539.6879-3.5073,1.7194l1.3068,1.1689c.4296-.6189,1.0144-1.1344,2.0454-1.1344,1.1694,0,1.668.5844,1.668,1.5817v.6531h-1.5304Zm1.5304,2.51c0,.8425-.7908,1.2893-1.7705,1.2893-.8601,0-1.3586-.3608-1.3586-1.0833v-.292c0-.7048.5679-1.1002,1.7194-1.1002h1.4098v1.1862Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9.272,17.427h3.1287c2.218,0,3.5588-1.4785,3.5588-3.7133,0-2.2181-1.3408-3.7137-3.5588-3.7137h-5.3981v12h2.2694v-4.573Zm0-5.4501h2.9225c.8767,0,1.4098.4642,1.4098,1.3414v.7908c0,.8767-.5331,1.358-1.4098,1.358h-2.9225v-3.4902Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
})));
if (false) {}
const PartitionAuto = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartitionAuto({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "m26,19c-2.2056,0-4,1.7944-4,4,0,.6836.1882,1.3174.4917,1.8809-1.8762,1.3726-4.146,2.1191-6.4917,2.1191-6.0654,0-11-4.9346-11-11h-2c0,7.168,5.8318,13,13,13,2.8455,0,5.5923-.936,7.8433-2.6416.6235.4019,1.3613.6416,2.1567.6416,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m16,3c-2.8455,0-5.5923.936-7.8433,2.6416-.6235-.4019-1.3613-.6416-2.1567-.6416-2.2056,0-4,1.7944-4,4s1.7944,4,4,4,4-1.7944,4-4c0-.6836-.1882-1.3174-.4917-1.8809,1.8762-1.3726,4.146-2.1191,6.4917-2.1191,6.0654,0,11,4.9346,11,11h2c0-7.168-5.8318-13-13-13ZM6,11c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
})));
if (false) {}
const PartitionCollection = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartitionCollection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "m26,12c-1.8584,0-3.4106,1.2798-3.8579,3h-2.7278c-.5344,0-1.0366.208-1.4143.5859l-5.4143,5.4141H2v2h10.5857c.5344,0,1.0366-.208,1.4143-.5859l5.4143-5.4141h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m16.1717,14.5859l-3.5859-3.5859H2v-2h10.5857c.5344,0,1.0366.208,1.4143.5859l3.5859,3.5859-1.4143,1.4141Z"
  })), children);
})));
if (false) {}
const PartitionRepartition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartitionRepartition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m26,6c-1.8584,0-3.4106,1.2798-3.8579,3h-2.7278c-.5344,0-1.0366.208-1.4143.5859l-3.5864,3.5864,1.4141,1.4141,3.5867-3.5864h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "m10.1716,17.4141l-3.5859,3.5859H2v2h4.5857c.5344,0,1.0366-.208,1.4143-.5859l3.5859-3.5859-1.4143-1.4141Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "m26,18c-1.8584,0-3.4106,1.2798-3.8579,3h-2.728l-11.4141-11.4141c-.3777-.3779-.8799-.5859-1.4143-.5859H2v2h4.5859l11.4141,11.4141c.3777.3779.8799.5859,1.4143.5859h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
})));
if (false) {}
const PartitionSame = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartitionSame({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "m26,18c-1.8584,0-3.4106,1.2798-3.8579,3H2v2h20.1421c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "m26,6c-1.8584,0-3.4106,1.2798-3.8579,3H2v2h20.1421c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
})));
if (false) {}
const PartitionSpecific = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartitionSpecific({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m26,18c-1.8584,0-3.4106,1.2798-3.8579,3h-2.728l-5.4141-5.4141c-.3777-.3779-.8799-.5859-1.4143-.5859H2v2h10.5859l5.4141,5.4141c.3777.3779.8799.5859,1.4143.5859h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m26,6c-1.8584,0-3.4106,1.2798-3.8579,3h-2.7278c-.5344,0-1.0366.208-1.4143.5859l-3.5864,3.5864,1.4141,1.4141,3.5867-3.5864h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
})));
if (false) {}
const PartlyCloudy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartlyCloudy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H31V17H27z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M23.086 5.794H27.329V7.794H23.086z",
    transform: "rotate(-45 25.207 6.794)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H17V5H15z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M4.672 24.208H8.915V26.208H4.672z",
    transform: "rotate(-45 6.793 25.208)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M5.793 4.672H7.793V8.915H5.793z",
    transform: "rotate(-45 6.793 6.794)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15H5V17H1z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7939,20.3418a6.9617,6.9617,0,0,0-1.8681-3.2671A8.485,8.485,0,0,0,25,16a9,9,0,1,0-14.585,7.0332A4.9771,4.9771,0,0,0,15,30H25a4.9947,4.9947,0,0,0,1.7939-9.6582ZM9,16a6.9955,6.9955,0,0,1,13.9849-.2969A6.8883,6.8883,0,0,0,20,15a7.04,7.04,0,0,0-6.7944,5.3418A4.986,4.986,0,0,0,11.5618,21.39,6.9675,6.9675,0,0,1,9,16ZM25,28H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,28Z"
  })), children);
})));
if (false) {}
const PartlyCloudyNight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PartlyCloudyNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
  })), children);
})));
if (false) {}
const Partnership = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Partnership({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9a4,4,0,1,1,4-4A4,4,0,0,1,8,9ZM8,3a2,2,0,1,0,2,2A2,2,0,0,0,8,3Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M24,9a4,4,0,1,1,4-4A4,4,0,0,1,24,9Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,24,3Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H22a2,2,0,0,1-2-2V21h2v7h4V19h2V13a1,1,0,0,0-1-1H20.58L16,20l-4.58-8H5a1,1,0,0,0-1,1v6H6v9h4V21h2v7a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V21a2,2,0,0,1-2-2V13a3,3,0,0,1,3-3h7.58L16,16l3.42-6H27a3,3,0,0,1,3,3v6a2,2,0,0,1-2,2v7A2,2,0,0,1,26,30Z"
  })), children);
})));
if (false) {}
const PassengerDrinks = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PassengerDrinks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4V2H22V4a3.9906,3.9906,0,0,0,3,3.8586V11H23v2h6V11H27V7.8586A3.9906,3.9906,0,0,0,30,4Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,9A3.5,3.5,0,1,1,14,5.5,3.5042,3.5042,0,0,1,10.5,9Zm0-5A1.5,1.5,0,1,0,12,5.5,1.5017,1.5017,0,0,0,10.5,4Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4746,31.313,19.3408,24H12.2393A4.0073,4.0073,0,0,1,8.373,21.0293l-1.6337-6.126a3.8987,3.8987,0,0,1,7.5341-2.0092L15.1016,16H21v2H13.5645l-1.2227-4.5908a1.9,1.9,0,0,0-3.6709.979l1.6338,6.1255A2.0052,2.0052,0,0,0,12.2393,22h8.42l3.6543,8.5254Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
  })), children);
})));
if (false) {}
const PassengerPlus = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PassengerPlus({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,9A3.5,3.5,0,1,1,14,5.5,3.5042,3.5042,0,0,1,10.5,9Zm0-5A1.5,1.5,0,1,0,12,5.5,1.5017,1.5017,0,0,0,10.5,4Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4739,31.313,19.34,24H12.2385a4.0072,4.0072,0,0,1-3.8662-2.9707l-1.6338-6.126a3.8988,3.8988,0,0,1,7.5342-2.0092L15.1008,16H21v2H13.5637l-1.2226-4.5908a1.9,1.9,0,0,0-3.6709.979l1.6338,6.1255A2.0051,2.0051,0,0,0,12.2385,22h8.42l3.6543,8.5254Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6 26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
  })), children);
})));
if (false) {}
const Password = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Password({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), children);
})));
if (false) {}
const Paste = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Paste({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
  })), children);
})));
if (false) {}
const Pause = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Pause({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path244 || (_path244 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M6,4v8H4V4H6 M6,3H4C3.4,3,3,3.4,3,4v8c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V4C7,3.4,6.6,3,6,3z"
    })), _path245 || (_path245 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M12,4v8h-2V4H12 M12,3h-2C9.4,3,9,3.4,9,4v8c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3z"
    })), children);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12,8V24H8V8h4m0-2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), _path247 || (_path247 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24,8V24H20V8h4m0-2H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
});
if (false) {}
const PauseFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PauseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6H10A2,2,0,0,0,8,8V24a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22,6H20a2,2,0,0,0-2,2V24a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2Z"
  })), children);
})));
if (false) {}
const PauseOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PauseOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
      d: "M7 5 6 5 6 11 7 11 7 5z"
    })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
      d: "M10 5 9 5 9 11 10 11 10 5z"
    })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10 12 10 12 22 14 22 14 10 14 10z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10 18 10 18 22 20 22 20 10 20 10z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
})));
if (false) {}
const PauseOutlineFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PauseOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
  })), children);
})));
if (false) {}
const PauseFuture = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PauseFuture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11 12 11 12 22 14 22 14 11 14 11z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11 18 11 18 22 20 22 20 11 20 11z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
})));
if (false) {}
const PausePast = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PausePast({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11 12 11 12 22 14 22 14 11 14 11z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11 18 11 18 22 20 22 20 11 20 11z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
})));
if (false) {}
const PcnENode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PcnENode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11 20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
})));
if (false) {}
const PcnMilitary = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PcnMilitary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16 14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 17.414 16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 12.414 16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
})));
if (false) {}
const PcnPNode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PcnPNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
})));
if (false) {}
const PcnZNode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PcnZNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9 12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
})));
if (false) {}
const Pdf = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pdf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11 30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9H2V23H4V18H8a2,2,0,0,0,2-2V11A2,2,0,0,0,8,9Zm0,7H4V11H8Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H12V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,16,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H14Z"
  })), children);
})));
if (false) {}
const PdfReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PdfReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16 24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2H12V16h4a4,4,0,0,0,4-4V6A4,4,0,0,0,16,2Zm2,10a2,2,0,0,1-2,2H14V4h2a2,2,0,0,1,2,2Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M8,2H2V16H4V11H8a2,2,0,0,0,2-2V4A2,2,0,0,0,8,2ZM8,9H4V4H8Z"
  })), children);
})));
if (false) {}
const Pedestrian = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pedestrian({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M17.051 18.316 19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,8A3.5,3.5,0,1,1,20,4.5,3.5042,3.5042,0,0,1,16.5,8Zm0-5A1.5,1.5,0,1,0,18,4.5,1.5017,1.5017,0,0,0,16.5,3Z"
  })), children);
})));
if (false) {}
const PedestrianFamily = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PedestrianFamily({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H17a2.0021,2.0021,0,0,1-2-2V23h2v5h3V23h2V19a1.0011,1.0011,0,0,0-1-1H12.2793l-2-6H4a1.0011,1.0011,0,0,0-1,1v6H5v9H9V21h2v7a2.0021,2.0021,0,0,1-2,2H5a2.0021,2.0021,0,0,1-2-2V21a2.0021,2.0021,0,0,1-2-2V13a3.0033,3.0033,0,0,1,3-3h6.2793a1.998,1.998,0,0,1,1.8975,1.3674L13.7207,16H21a3.0033,3.0033,0,0,1,3,3v4a2.0021,2.0021,0,0,1-2,2v3A2.0021,2.0021,0,0,1,20,30Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H26V19h3V13a1.0011,1.0011,0,0,0-1-1H24V10h4a3.0033,3.0033,0,0,1,3,3v6a2.0021,2.0021,0,0,1-2,2H28Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M7,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,7,9ZM7,3A2,2,0,1,0,9,5,2.0021,2.0021,0,0,0,7,3Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M25,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,25,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,25,3Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
  })), children);
})));
if (false) {}




/***/ }),

/***/ 1409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sh": function() { return /* binding */ Play; }
/* harmony export */ });
/* unused harmony exports PedestrianChild, Pen, PenFountain, Pending, PendingFilled, PentagonDownOutline, PentagonDownSolid, PentagonLeftOutline, PentagonLeftSolid, PentagonOutline, PentagonRightOutline, PentagonRightSolid, PentagonSolid, Percentage, PercentageFilled, PerformAction, Person, PersonFavorite, Pest, Phone, PhoneApplication, PhoneBlock, PhoneBlockFilled, PhoneFilled, PhoneIncoming, PhoneIncomingFilled, PhoneIp, PhoneOff, PhoneOffFilled, PhoneOutgoing, PhoneOutgoingFilled, PhoneSettings, PhoneVoice, PhoneVoiceFilled, PhraseSentiment, PicnicArea, PiggyBank, PiggyBankSlot, Pills, PillsAdd, PillsSubtract, Pin, PinFilled, Pipelines, PivotHorizontal, PivotVertical, Plan, Plane, PlanePrivate, PlaneSea, PlatformAutomation, Platforms, PlayFilled, PlayFilledAlt, PlayOutline, PlayOutlineFilled, Playlist, Pli, Plug, PlugFilled, Png, Point, PointOfPresence, Police, Policy, PopIn, Popup, PortDefinition, PortInput, PortOutput, PortUsage, Portfolio, Power, PowerEnterprisePoolsMeteredCapacityIntegration, PowerVirtualServerDisasterRecoveryAutomation, Ppt, PresentationFile, Pressure, PressureFilled, PreviousFilled, PreviousOutline, PricingConsumption, PricingContainer, PricingQuickProposal, PricingTailored, PricingTraditional, Printer, PrivateNetwork, Process, ProcessAutomate, Product, ProgressBar, ProgressBarRound, Promote, PromptSession, PromptTemplate, PropertyRelationship, PullRequest, PunctuationCheck, Purchase, Qiskit, QqPlot, QrCode, QuadrantPlot, Query, QueryQueue, QuestionAnswering, Queued, Quotes, Radar, RadarEnhanced, RadarWeather, Radio, RadioButton, RadioButtonChecked, RadioCombat, RadioPushToTalk, Rag, Rain, RainDrizzle, WatsonHealthPetImageB, WatsonHealthPetImageO, WatsonHealthPointerText, WatsonHealthQcLaunch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle4, _circle5, _circle6, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _circle7, _circle8, _circle9, _path238, _path239, _path240, _path241, _circle0, _circle1, _circle10, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _circle11, _circle12, _circle13, _circle14, _circle15, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _circle24, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329;
const PedestrianChild = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PedestrianChild({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,15A3.5,3.5,0,1,1,27,11.5,3.5042,3.5042,0,0,1,23.5,15Zm0-5A1.5,1.5,0,1,0,25,11.5,1.5017,1.5017,0,0,0,23.5,10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,8,9ZM8,3a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,8,3Z"
  })), children);
})));
if (false) {}
const Pen = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.136 7.5H18.863999999999997V9.5H8.136z",
    transform: "rotate(-45 13.5 8.5)"
  })), children);
})));
if (false) {}
const PenFountain = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PenFountain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
  })), children);
})));
if (false) {}
const Pending = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const PendingFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PendingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const PentagonDownOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PentagonDownOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,27.7593l-11.8274-8.6831,4.5261-14.0762h14.6025l4.5261,14.0762-11.8274,8.6831m0,2.2407c.2078,0,.4158-.0645.5918-.1938l13-9.5444c.2599-.1907.4066-.4904.4082-.8009.0005-.1036-.0151-.2085-.0481-.3109l-4.9697-15.4561c-.1331-.4136-.5176-.6938-.9519-.6938H7.9697c-.4343,0-.8188.2803-.9519.6938l-4.9697,15.4561c-.0329.1021-.0485.2067-.0481.31.0013.3108.1481.6109.4082.8018l13,9.5444c.176.1294.384.1938.5918.1938h0Z"
  })), children);
})));
if (false) {}
const PentagonDownSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PentagonDownSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30c.2078,0,.4158-.0645.5918-.1938l13-9.5444c.2599-.1907.4066-.4904.4082-.8009.0005-.1036-.0151-.2085-.0481-.3109l-4.9697-15.4561c-.1331-.4136-.5176-.6938-.9519-.6938H7.9697c-.4343,0-.8188.2803-.9519.6938l-4.9697,15.4561c-.0329.1021-.0485.2067-.0481.31.0013.3108.1481.6109.4082.8018l13,9.5444c.176.1294.384.1938.5918.1938h0Z"
  })), children);
})));
if (false) {}
const PentagonLeftOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PentagonLeftOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.2407,16L12.9238,4.1726l14.0762,4.5261v14.6025l-14.0762,4.5261-8.6831-11.8274m-2.2407,0c0,.2078.0645.4158.1938.5918l9.5444,13c.1907.2599.4904.4066.8009.4082.1036.0005.2085-.0151.3109-.0481l15.4561-4.9697c.4136-.1331.6938-.5176.6938-.9519V7.9697c0-.4343-.2803-.8188-.6938-.9519L12.8501,2.0481c-.1021-.0329-.2067-.0485-.31-.0481-.3108.0013-.6109.1481-.8018.4082L2.1938,15.4082c-.1294.176-.1938.384-.1938.5918h0Z"
  })), children);
})));
if (false) {}
const PentagonLeftSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PentagonLeftSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,16c0,.2078.0645.4158.1938.5918l9.5444,13c.1907.2599.4904.4066.8009.4082.1036.0005.2085-.0151.3109-.0481l15.4561-4.9697c.4136-.1331.6938-.5176.6938-.9519V7.9697c0-.4343-.2803-.8188-.6938-.9519L12.8501,2.0481c-.1021-.0329-.2067-.0485-.31-.0481-.3108.0013-.6109.1481-.8018.4082L2.1938,15.4082c-.1294.176-.1938.384-.1938.5918h0Z"
  })), children);
})));
if (false) {}
const PentagonOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PentagonOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,4.2407l11.8274,8.6831-4.5261,14.0762h-14.6025l-4.5261-14.0762,11.8274-8.6831m0-2.2407c-.2078,0-.4158.0645-.5918.1938L2.4082,11.7383c-.2599.1907-.4066.4904-.4082.8009-.0005.1036.0151.2085.0481.3109l4.9697,15.4561c.1331.4136.5176.6938.9519.6938h16.0605c.4343,0,.8188-.2803.9519-.6938l4.9697-15.4561c.0329-.1021.0485-.2067.0481-.31-.0013-.3108-.1481-.6109-.4082-.8018L16.5918,2.1938c-.176-.1294-.384-.1938-.5918-.1938h0Z"
  })), children);
})));
if (false) {}
const PentagonRightOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PentagonRightOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27.7593,16l-8.6831,11.8274-14.0762-4.5261v-14.6025l14.0762-4.5261,8.6831,11.8274m2.2407,0c0-.2078-.0645-.4158-.1938-.5918L20.2617,2.4082c-.1907-.2599-.4904-.4066-.8009-.4082-.1036-.0005-.2085.0151-.3109.0481L3.6938,7.0178c-.4136.1331-.6938.5176-.6938.9519v16.0605c0,.4343.2803.8188.6938.9519l15.4561,4.9697c.1021.0329.2067.0485.31.0481.3108-.0013.6109-.1481.8018-.4082l9.5444-13c.1294-.176.1938-.384.1938-.5918h0Z"
  })), children);
})));
if (false) {}
const PentagonRightSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PentagonRightSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,16c0-.2078-.0645-.4158-.1938-.5918L20.2617,2.4082c-.1907-.2599-.4904-.4066-.8009-.4082-.1036-.0005-.2085.0151-.3109.0481L3.6938,7.0178c-.4136.1331-.6938.5176-.6938.9519v16.0605c0,.4343.2803.8188.6938.9519l15.4561,4.9697c.1021.0329.2067.0485.31.0481.3108-.0013.6109-.1481.8018-.4082l9.5444-13c.1294-.176.1938-.384.1938-.5918h0Z"
  })), children);
})));
if (false) {}
const PentagonSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PentagonSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-.2078,0-.4158.0645-.5918.1938L2.4082,11.7383c-.2599.1907-.4066.4904-.4082.8009-.0005.1036.0151.2085.0481.3109l4.9697,15.4561c.1331.4136.5176.6938.9519.6938h16.0605c.4343,0,.8188-.2803.9519-.6938l4.9697-15.4561c.0329-.1021.0485-.2067.0481-.31-.0013-.3108-.1481-.6109-.4082-.8018L16.5918,2.1938c-.176-.1294-.384-.1938-.5918-.1938h0Z"
  })), children);
})));
if (false) {}
const Percentage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Percentage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M.029 15H31.97V17H.029z",
    transform: "rotate(-45 16 16)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
  })), children);
})));
if (false) {}
const PercentageFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PercentageFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M.029 15H31.97V17H.029z",
    transform: "rotate(-45 16 16)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
  })), children);
})));
if (false) {}
const PerformAction = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PerformAction({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2h-10C6,2,2,6,2,11v10c0,5,4,9,9,9h10c5,0,9-4,9-9v-10c0-5-4-9-9-9ZM28,21c0,3.9-3.1,7-7,7h-10c-3.9,0-7-3.1-7-7v-10c0-3.9,3.1-7,7-7h10c3.9,0,7,3.1,7,7v10ZM24,11h-6c-1.1,0-2,.9-2,2v6c0,1.1.9,2,2,2h6c1.1,0,2-.9,2-2v-6c0-1.1-.9-2-2-2ZM18,19v-6h6v6h-6ZM11,11l5,5-5,5-1.5-1.4,2.7-2.6h-6.2v-2h6.2l-2.7-2.6,1.5-1.4Z"
  })), children);
})));
if (false) {}
const Person = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Person({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H14a2,2,0,0,1-2-2V21a2,2,0,0,1-2-2V13a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v6a2,2,0,0,1-2,2v7A2,2,0,0,1,18,30ZM13,12a.94.94,0,0,0-1,1v6h2v9h4V19h2V13a.94.94,0,0,0-1-1Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9a4,4,0,1,1,4-4h0A4,4,0,0,1,16,9Zm0-6a2,2,0,1,0,2,2h0a2,2,0,0,0-2-2Z"
  })), children);
})));
if (false) {}
const PersonFavorite = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PersonFavorite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10,31H6a2.0059,2.0059,0,0,1-2-2V22a2.0059,2.0059,0,0,1-2-2V14a2.9465,2.9465,0,0,1,3-3h6a2.9465,2.9465,0,0,1,3,3v6a2.0059,2.0059,0,0,1-2,2v7A2.0059,2.0059,0,0,1,10,31ZM5,13a.9448.9448,0,0,0-1,1v6H6v9h4V20h2V14a.9448.9448,0,0,0-1-1Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,8,10ZM8,4a2,2,0,1,0,2,2A2.002,2.002,0,0,0,8,4Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7663,4.2558A4.2121,4.2121,0,0,0,23,4.0321a4.2121,4.2121,0,0,0-5.7663.2237,4.319,4.319,0,0,0,0,6.0447L22.998,16.14,23,16.1376l.002.0019,5.7643-5.839A4.319,4.319,0,0,0,28.7663,4.2558ZM27.342,8.8948l-4.34,4.3973L23,13.29l-.002.002-4.34-4.3973a2.3085,2.3085,0,0,1,0-3.2338,2.2639,2.2639,0,0,1,3.1561,0l1.181,1.2074L23,6.8634l.0049.005,1.181-1.2074a2.2639,2.2639,0,0,1,3.1561,0A2.3085,2.3085,0,0,1,27.342,8.8948Z"
  })), children);
})));
if (false) {}
const Pest = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "9.5",
    r: "1.5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "13",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "21",
    r: "1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
  })), children);
})));
if (false) {}
const WatsonHealthPetImageB = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthPetImageB({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H21V24H19z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H21V3H19z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H11V13H8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11H32V13H29z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 3.07H13.57V6.07H11.59z",
    transform: "rotate(-45 12.586 4.577)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.44 17.92H28.42V20.92H26.44z",
    transform: "rotate(-45 27.43 19.408)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 18.42H14.09V20.400000000000002H11.09z",
    transform: "rotate(-45 12.592 19.414)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.93 3.58H28.93V5.5600000000000005H25.93z",
    transform: "rotate(-45 27.423 4.57)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20,5a7,7,0,1,0,7,7A7,7,0,0,0,20,5Zm0,12A5,5,0,0,1,20,7Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M5,18H0V32H5a3,3,0,0,0,3-3V27a3,3,0,0,0-.78-2A3,3,0,0,0,8,23V21A3,3,0,0,0,5,18ZM2,20H5a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H2Zm4,9a1,1,0,0,1-1,1H2V26H5a1,1,0,0,1,1,1Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2 9 2 9 0 0 0 0 9 2 9 2 2z"
  })), children);
})));
if (false) {}
const WatsonHealthPetImageO = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthPetImageO({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H13V32H11z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H13V11H11z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19H3V21H0z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19H24V21H21z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59 11.09H5.57V14.09H3.59z",
    transform: "rotate(-45 4.585 12.59)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.44 25.93H20.42V28.93H18.44z",
    transform: "rotate(-45 19.429 27.422)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09 26.44H6.09V28.42H3.09z",
    transform: "rotate(-45 4.591 27.428)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.93 11.59H20.93V13.57H17.93z",
    transform: "rotate(-45 19.423 12.585)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12,13a7,7,0,1,0,7,7A7,7,0,0,0,12,13Zm0,12a5,5,0,0,1,0-10Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2 9 2 9 0 0 0 0 9 2 9 2 2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30,0H26a2,2,0,0,0-2,2V12a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V2A2,2,0,0,0,30,0ZM26,12V2h4V12Z"
  })), children);
})));
if (false) {}
const Phone = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Phone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), children);
})));
if (false) {}
const PhoneApplication = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneApplication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H30V6H26z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H30V12H26z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H24V6H20z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H24V12H20z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
  })), children);
})));
if (false) {}
const PhoneBlock = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneBlock({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 9 28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), children);
})));
if (false) {}
const PhoneBlockFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneBlockFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 9 28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), children);
})));
if (false) {}
const PhoneFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
  })), children);
})));
if (false) {}
const PhoneIncoming = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneIncoming({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13 27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
  })), children);
})));
if (false) {}
const PhoneIncomingFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneIncomingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13 27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
  })), children);
})));
if (false) {}
const PhoneIp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneIp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H18V16H16z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H22V16H20z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26V16H24z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H18V20H16z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18H26V20H24z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H18V24H16z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H22V24H20z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H26V24H24z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10H26V12H16z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
  })), children);
})));
if (false) {}
const PhoneOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19,18.56A25.66,25.66,0,0,1,5,6.08V6A1,1,0,0,1,6,5h5.28l1.5,3.77L9.94,11.64l.06.48a13,13,0,0,0,1.46,4.17l1.46-1.46a9.34,9.34,0,0,1-.84-2.52l2.13-2.15A2,2,0,0,0,14.65,8L13.13,4.26A2,2,0,0,0,11.27,3H5.76A3,3,0,0,0,3,6.23,28,28,0,0,0,7.79,20Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M27.77,18.86,24,17.35a2,2,0,0,0-2.17.41l-2.17,2.15A9.17,9.17,0,0,1,15.45,18L30,3.41,28.59,2,2,28.59,3.41,30l7-7c3.38,3.18,8.28,5.62,15.39,6H26a3,3,0,0,0,3-3V20.72A2,2,0,0,0,27.77,18.86ZM27,26v.06a1,1,0,0,1-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14,19.44A10.77,10.77,0,0,0,19.88,22l.48.06,2.87-2.85L27,20.72Z"
  })), children);
})));
if (false) {}
const PhoneOffFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M26.74,19.56l-2.52-1a2,2,0,0,0-2.15.44L20,21.06a9.93,9.93,0,0,1-5.35-2.29L30,3.41,28.59,2,2,28.59,3.41,30l7.93-7.92c3.24,3.12,7.89,5.5,14.55,5.92A2,2,0,0,0,28,26V21.41A2,2,0,0,0,26.74,19.56Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15,18.19l3.52-3.52A11.68,11.68,0,0,1,10.85,12l2.07-2.07a2,2,0,0,0,.44-2.15l-1-2.52A2,2,0,0,0,10.5,4H6A2,2,0,0,0,4,6.22,29,29,0,0,0,8.15,18.19Z"
  })), children);
})));
if (false) {}
const PhoneOutgoing = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneOutgoing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8 c0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26 C29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3 l-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4 20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
  })), children);
})));
if (false) {}
const PhoneOutgoingFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneOutgoingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4 20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
  })), children);
})));
if (false) {}
const PhoneSettings = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneSettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
  })), children);
})));
if (false) {}
const PhoneVoice = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneVoice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13H26a7.0078,7.0078,0,0,0-7-7V4A9.01,9.01,0,0,1,28,13Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), children);
})));
if (false) {}
const PhoneVoiceFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhoneVoiceFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13H26a7.0078,7.0078,0,0,0-7-7V4A9.01,9.01,0,0,1,28,13Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), children);
})));
if (false) {}
const PhraseSentiment = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PhraseSentiment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
})));
if (false) {}
const PicnicArea = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PicnicArea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24,12a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,12Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,6Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22H21.8472L21.18,18H24V16H8v2h2.82l-.6668,4H6v2H9.82l-.6668,4H11.18l.6668-4h8.3056l.6668,4h2.0276L22.18,24H26ZM12.18,22l.6665-4h6.3062l.6665,4Z"
  })), children);
})));
if (false) {}
const PiggyBank = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PiggyBank({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
  })), children);
})));
if (false) {}
const PiggyBankSlot = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PiggyBankSlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H20V13H13z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
  })), children);
})));
if (false) {}
const Pills = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pills({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
  })), children);
})));
if (false) {}
const PillsAdd = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PillsAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21 23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
  })), children);
})));
if (false) {}
const PillsSubtract = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PillsSubtract({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H25V23H19z"
  })), children);
})));
if (false) {}
const Pin = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
  })), children);
})));
if (false) {}
const PinFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PinFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
  })), children);
})));
if (false) {}
const Pipelines = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pipelines({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M22,12h6c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-6c-1.1028,0-2,.8975-2,2v2h-9c-2.7571,0-5,2.2432-5,5h-2c-1.1028,0-2,.8975-2,2v6c0,1.1025.8972,2,2,2h2c0,2.7568,2.2429,5,5,5h9v2c0,1.1025.8972,2,2,2h6c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2h-6c-1.1028,0-2,.8975-2,2v2h-9c-1.6543,0-3-1.3457-3-3h2c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2h-2c0-1.6543,1.3457-3,3-3h9v2c0,1.1025.8972,2,2,2ZM22,22h6v6h-6l-.0012-6h.0012ZM10,13v6h-6l-.0012-6h6.0012ZM22,4h6v6h-6l-.0012-6h.0012Z"
  })), children);
})));
if (false) {}
const PivotHorizontal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PivotHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1,2H3.9c-1.1,0-1.9.9-1.9,1.9v24.2c0,1.1.9,1.9,1.9,1.9h24.2c1.1,0,1.9-.9,1.9-1.9V3.9c0-1.1-.9-1.9-1.9-1.9ZM28,28H4V8h24s0,20,0,20ZM28,6H4v-2h24s0,2,0,2ZM22,19l-1.4,1.4-2.6-2.6v6.2c0,1.1-.9,2-2,2h-6v-2h6v-6.2l-2.6,2.6-1.4-1.4,5-5,5,5ZM8,12v-2h16v2H8Z"
  })), children);
})));
if (false) {}
const PivotVertical = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PivotVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h24c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2ZM28,28H4V8h24v20ZM28,6H4v-2h24v2ZM22,10h2v16h-2v-16ZM15,14l5,5-5,5-1.4-1.4,2.6-2.6h-6.2c-1.1,0-2-.9-2-2v-6h2v6h6.2l-2.6-2.6,1.4-1.4Z"
  })), children);
})));
if (false) {}
const Plan = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Plan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4 C1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7 l6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4 l-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
  })), children);
})));
if (false) {}
const Plane = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Plane({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
  })), children);
})));
if (false) {}
const PlanePrivate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PlanePrivate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
  })), children);
})));
if (false) {}
const PlaneSea = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PlaneSea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28a4.9316,4.9316,0,0,1-4-1.9873,5.0192,5.0192,0,0,1-8,0,5.0192,5.0192,0,0,1-8,0A4.9316,4.9316,0,0,1,4,30H2V28H4a3.44,3.44,0,0,0,3.0532-2.3215A.9712.9712,0,0,1,8,25a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,12,28a3.44,3.44,0,0,0,3.0532-2.3215A.99.99,0,0,1,16,25a1.0069,1.0069,0,0,1,.9487.6838A3.4381,3.4381,0,0,0,20,28a3.44,3.44,0,0,0,3.0532-2.3215,1,1,0,0,1,1.8955.0053A3.4381,3.4381,0,0,0,28,28h2Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6v4H25.5L23.4,7.2A3.0129,3.0129,0,0,0,21,6H15a3.0033,3.0033,0,0,0-3,3v1H8.6182L7.8945,8.5527l-1-2A1,1,0,0,0,6,6H3A1,1,0,0,0,2,7v6a3.0033,3.0033,0,0,0,3,3h6.82l-.6666,4H7a1,1,0,0,0,0,2H27a1,1,0,0,0,0-2H22.847L22.18,16h.1629a4.9662,4.9662,0,0,0,3.5351-1.4648L28,12.4141V16h2V6ZM14,9a1.0009,1.0009,0,0,1,1-1h6a1.0045,1.0045,0,0,1,.8.4L23,10H14Zm6.82,11H13.18l.6666-4h6.306Zm1.5237-6H5a1.0009,1.0009,0,0,1-1-1V8H5.3818l.7237,1.4473L7.3818,12h18.204l-1.1214,1.1211A2.9789,2.9789,0,0,1,22.3433,14Z"
  })), children);
})));
if (false) {}
const PlatformAutomation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PlatformAutomation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M5,25V15.8281l-3.5859,3.586L0,18l6-6,6,6-1.4141,1.4141L7,15.8281V25H19v2H7A2.0024,2.0024,0,0,1,5,25Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24,22h4a2.002,2.002,0,0,1,2,2v4a2.002,2.002,0,0,1-2,2H24a2.002,2.002,0,0,1-2-2V24A2.002,2.002,0,0,1,24,22Zm4,6V24H23.9985L24,28Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M27,6v9.1719l3.5859-3.586L32,13l-6,6-6-6,1.4141-1.4141L25,15.1719V6H13V4H25A2.0024,2.0024,0,0,1,27,6Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H8V8H2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H10V4H2z"
  })), children);
})));
if (false) {}
const Platforms = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Platforms({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m28,28H4c-1.1028,0-2-.8972-2-2v-6h2v6h24v-6h2v6c0,1.1028-.8972,2-2,2Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m17,17v4c0,.5522.4477,1,1,1h4c.5523,0,1-.4478,1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523,0-1,.4477-1,1Zm2,1h2v2h-2v-2Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m9,17v4c0,.5522.4477,1,1,1h4c.5523,0,1-.4478,1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523,0-1,.4477-1,1Zm2,1h2v2h-2v-2Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m17,9v4c0,.5522.4477,1,1,1h4c.5523,0,1-.4478,1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523,0-1,.4477-1,1Zm2,1h2v2h-2v-2Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m5,5v8c0,.5522.4477,1,1,1h8c.5523,0,1-.4478,1-1V5c0-.5523-.4477-1-1-1H6c-.5523,0-1,.4477-1,1Zm2,1h6v6h-6v-6Z"
  })), children);
})));
if (false) {}
const Play = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Play({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path127 || (_path127 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M3.5,14C3.2,14,3,13.8,3,13.5v-11c0-0.2,0.1-0.3,0.2-0.4C3.4,2,3.6,2,3.8,2.1l9.5,5.5c0.2,0.1,0.3,0.4,0.2,0.7 c0,0.1-0.1,0.1-0.2,0.2l-9.5,5.5C3.7,14,3.6,14,3.5,14z M4,3.4v9.3L12,8L4,3.4z"
    })), children);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z"
  })), children);
});
if (false) {}
const PlayFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PlayFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
  })), children);
})));
if (false) {}
const PlayFilledAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PlayFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
  })), children);
})));
if (false) {}
const PlayOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PlayOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
      d: "M6,11.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4V5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3 C12,7.7,12.1,8,11.9,8.2c0,0.1-0.1,0.2-0.2,0.2l-5.5,3C6.2,11.5,6.1,11.5,6,11.5z M6.5,5.8v4.3l4-2.2L6.5,5.8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
})));
if (false) {}
const PlayOutlineFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PlayOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
    })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
      d: "M6.5 10.2 10.5 8 6.5 5.8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.382 20.764 16 12 11.618 12 20.382z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
  })), children);
})));
if (false) {}
const Playlist = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Playlist({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H22V8H4z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H22V14H4z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H16V20H4z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18 28 23 21 28 21 18z"
  })), children);
})));
if (false) {}
const Pli = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pli({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9h8v2h-3v10h3v2h-8v-2h3v-10h-3v-2ZM14,21v-12h-2v14h8v-2h-6ZM4,18h4c1.103,0,2-.897,2-2v-5c0-1.103-.897-2-2-2H2v14h2v-5ZM4,10.9985h4v5.0015h-4v-5.0015Z"
  })), children);
})));
if (false) {}
const Plug = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Plug({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
  })), children);
})));
if (false) {}
const PlugFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PlugFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
  })), children);
})));
if (false) {}
const Png = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Png({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23H24a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H24V21h4V17H26V15h4Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19 14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M4,23H2V9H8a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H4Zm0-7H8V11H4Z"
  })), children);
})));
if (false) {}
const Point = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Point({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0009,13c-.5165.0019-1.0234.1398-1.4696.4-.5478-.8691-1.5021-1.3974-2.5293-1.4-.5165.0019-1.0234.1398-1.4696.4-.749-1.1788-2.2121-1.6847-3.529-1.22v-5.18h0c0-1.6569-1.3427-3-2.9991-3s-2.9991,1.3431-2.9991,3v11.1l-2.2293-1.52h0c-.5111-.3807-1.1323-.5843-1.7695-.58-1.6564-.0041-3.0024,1.3357-3.0065,2.9926-.002.8025.3175,1.5723.8871,2.1374l7.9976,7.3c1.1323,1.0137,2.5992,1.5729,4.1188,1.57h4.9985c3.8648,0,6.9979-3.134,6.9979-7v-6c0-1.6569-1.3427-3-2.9991-3h.0002ZM26.0006,22c0,2.7614-2.2379,5-4.9985,5h-4.9985c-1.0105.0122-1.991-.3432-2.7592-1l-7.9476-7.3c-.1847-.1863-.2888-.4377-.2899-.7,0-.5523.4476-1,.9997-1,.2163,0,.4268.0702.5998.2l5.3984,3.7V6c0-.5523.4476-1,.9997-1s.9997.4477.9997,1h0v11h1.9994v-3c0-.5523.4476-1,.9997-1s.9997.4477.9997,1v3h1.9994v-2c0-.5523.4476-1,.9997-1s.9997.4477.9997,1v2h1.9994v-1c0-.5523.4476-1,.9997-1s.9997.4477.9997,1v6Z"
  })), children);
})));
if (false) {}
const PointOfPresence = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PointOfPresence({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H18a2.0021,2.0021,0,0,1-2-2V18a2.0021,2.0021,0,0,1,2-2h2v2H18V28H28V18H26V16h2a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M14,16H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H14a2.0021,2.0021,0,0,1,2,2V6H14V4H4V14H14V12h2v2A2.0021,2.0021,0,0,1,14,16Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
  })), children);
})));
if (false) {}
const WatsonHealthPointerText = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthPointerText({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 12.29 7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H12a2,2,0,0,1-2-2V18h2V28H28V12H18V10H28a2,2,0,0,1,2,2V28A2,2,0,0,1,28,30Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
  })), children);
})));
if (false) {}
const Police = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Police({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H12V30H10z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
  })), children);
})));
if (false) {}
const Policy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Policy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18A6,6,0,1,0,20,22.46v7.54l4-1.8926,4,1.8926V22.46A5.98,5.98,0,0,0,30,18Zm-4,8.84-2-.9467L22,26.84V23.65a5.8877,5.8877,0,0,0,4,0ZM24,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,22Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H16V16H9z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H19V10H9z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
  })), children);
})));
if (false) {}
const PopIn = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PopIn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6c-1.1025,0-2-.8975-2-2V6c0-1.1025.8975-2,2-2h8v2H6v20h20v-8.0267h2v8.0267c0,1.1025-.8975,2-2,2ZM28,14v-2l-6.586-.0266L30,3.3875l-1.4142-1.4142-8.5861,8.586.0003-6.5593h-2v10l9.9999-.0269v.0269Z"
  })), children);
})));
if (false) {}
const Popup = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Popup({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
  })), children);
})));
if (false) {}
const PortDefinition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PortDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19,7v-3.3999c0-.8837-.7164-1.6001-1.6001-1.6001H4v2h13v3h-6c-1.1046,0-2,.8954-2,2v14c0,1.1046.8954,2,2,2h6v3H4v2h13.3999c.8837,0,1.6001-.7164,1.6001-1.6001v-3.3999h6c1.1046,0,2-.8954,2-2v-14c0-1.1046-.8954-2-2-2h-6Zm6,16h-14v-14h14v14Z"
  })), children);
})));
if (false) {}
const PortInput = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PortInput({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16 16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
  })), children);
})));
if (false) {}
const PortOutput = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PortOutput({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16 23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
  })), children);
})));
if (false) {}
const PortUsage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PortUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,7h-2v-3.3999c0-.8999-.7002-1.6001-1.6001-1.6001H4v2h13v3h-2c-3.3,0-6,2.7002-6,6v6c0,3.2998,2.7,6,6,6h2v3H4v2h13.3999c.8999,0,1.6001-.7002,1.6001-1.6001v-3.3999h2c3.3,0,6-2.7002,6-6v-6c0-3.2998-2.7-6-6-6Zm4,12c0,2.2002-1.8,4-4,4h-6c-2.2,0-4-1.7998-4-4v-6c0-2.2002,1.8-4,4-4h6c2.2,0,4,1.7998,4,4v6Z"
  })), children);
})));
if (false) {}
const Portfolio = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Portfolio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
  })), children);
})));
if (false) {}
const Power = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Power({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
      d: "M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9 c-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z"
    })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 1H8.5V8H7.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V16H15z"
  })), children);
})));
if (false) {}
const PowerEnterprisePoolsMeteredCapacityIntegration = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PowerEnterprisePoolsMeteredCapacityIntegration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0166,29.9937c-7.7085,0-13.9863-6.2646-13.9995-13.9761-.0068-3.7358,1.4443-7.2534,4.0854-9.9043l1.417,1.4121c-2.2642,2.272-3.5083,5.2866-3.5024,8.4888.0054,3.2056,1.2588,6.2168,3.5293,8.4795,2.2651,2.2573,5.2725,3.5,8.4702,3.5h.021c1.3477-.0024,2.6533-.2212,3.8799-.6514l.6611,1.8877c-1.4385.5039-2.9653.7612-4.5381.7637h-.0239Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M15,16h2v4h2c1.1046,0,2,.8954,2,2v3h-2v-3h-2v3h-2v-3h-2v3h-2v-3c0-1.1046.8954-2,2-2h2v-4Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M23,26h0c.5523,0,1,.4477,1,1h0c0,.5523-.4477,1-1,1h0c-.5523,0-1-.4477-1-1h0c0-.5523.4477-1,1-1Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M9,4h0c.5523,0,1,.4477,1,1h0c0,.5523-.4477,1-1,1h0c-.5523,0-1-.4477-1-1h0c0-.5523.4477-1,1-1Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199,10.1064c-.4219-2.332-2.4678-4.1064-4.9199-4.1064s-4.498,1.7744-4.9199,4.1064c-1.7637.417-3.0801,2.0049-3.0801,3.8936,0,2.2061,1.7939,4,4,4h1v-2h-1c-1.1025,0-2-.8975-2-2s.8975-2,2-2h1v-1c0-1.6543,1.3457-3,3-3s3,1.3457,3,3v1h1c1.1025,0,2,.8975,2,2s-.8975,2-2,2h-1v2h1c2.2061,0,4-1.7939,4-4,0-1.8887-1.3164-3.4766-3.0801-3.8936Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8999,25.8885l-1.4141-1.4141c2.2681-2.2681,3.5171-5.2808,3.5171-8.4829,0-6.6167-5.3833-12-12-12-1.3491,0-2.6548.2168-3.8809.644l-.6582-1.8887c1.4385-.501,2.9653-.7554,4.5391-.7554,7.7197,0,14,6.2803,14,14,0,3.7363-1.457,7.251-4.103,9.897Z"
  })), children);
})));
if (false) {}
const PowerVirtualServerDisasterRecoveryAutomation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PowerVirtualServerDisasterRecoveryAutomation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16h0c0,.3369.024.6749.0714,1.006l-1.9795.2832c-.061-.4238-.0919-.858-.0919-1.2892,0-4.9629,4.0376-9,9-9,2.0435,0,4.0444.7041,5.6348,1.9814l-1.2529,1.5596c-1.2544-1.0083-2.7696-1.541-4.3819-1.541-3.8599,0-6.9999,3.1401-6.9999,7.0001h-.0001ZM8,20c0,.5522.4478,1,1,1s1-.4478,1-1-.4478-1-1-1-1,.4478-1,1ZM16,4c6.6166,0,12,5.3833,12,12h2c0-7.7197-6.2803-14-14-14-1.6431,0-3.2529.2822-4.7846.8389l.6836,1.8799c1.3115-.4771,2.6913-.7188,4.101-.7188ZM22,12c0,.5522.4478,1,1,1s1-.4478,1-1-.4478-1-1-1-1,.4478-1,1ZM9,6c.5522,0,1-.4478,1-1s-.4478-1-1-1-1,.4478-1,1,.4478,1,1,1ZM4,16h0c0-3.2051,1.2481-6.2188,3.5147-8.4854l-1.4141-1.4141c-2.6445,2.6445-4.1006,6.1603-4.1006,9.8995,0,7.7197,6.2803,14,14,14v-2c-6.6166,0-12-5.3832-12-12ZM28.5,25.5c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3c0-.4617.1135-.8942.3006-1.2853l-5.5153-5.5153c-.3911.1871-.8236.3006-1.2853.3006-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3c0,.4617-.1135.8942-.3006,1.2853l5.5153,5.5153c.3911-.1871.8236-.3006,1.2853-.3006,1.6543,0,3,1.3456,3,2.9999h0ZM16,17c.5513,0,1-.4487,1-1s-.4487-1-1-1-1,.4487-1,1,.4487,1,1,1ZM26.5,25.5c0-.5518-.4482-1-1-1s-1,.4482-1,1,.4482,1,1,1,1-.4482,1-1Z"
  })), children);
})));
if (false) {}
const Ppt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Ppt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11 25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M4,23H2V9H8a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H4Zm0-7H8V10.9985H4Z"
  })), children);
})));
if (false) {}
const PresentationFile = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PresentationFile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V18H15z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H22V18H20z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H12V18H10z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
  })), children);
})));
if (false) {}
const Pressure = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Pressure({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
  })), children);
})));
if (false) {}
const PressureFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PressureFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H10V25H6l10-9,10,9H22Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16,6,7h4V2H22V7h4Z"
  })), children);
})));
if (false) {}
const PreviousFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PreviousFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8 17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const PreviousOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PreviousOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8 17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const PricingConsumption = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PricingConsumption({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2v2c6.63,0,12,5.37,12,12s-5.37,12-12,12v2c7.73,0,14-6.27,14-14S23.73,2,16,2Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m8.24,25.14l-1.29,1.53c1.23,1.04,2.64,1.87,4.18,2.44l.68-1.88c-1.32-.49-2.53-1.2-3.58-2.09h.01Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.19,18l-1.97.41c.28,1.63.84,3.16,1.64,4.54l1.73-.95c-.68-1.18-1.16-2.61-1.4-4Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m5.59,10l-1.73-1c-.79,1.38-1.35,2.96-1.64,4.59l1.97.35c.24-1.39.72-2.75,1.4-3.93v-.01Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m11.82,4.76l-.68-1.88c-1.54.57-2.95,1.4-4.18,2.44l1.29,1.53c1.05-.89,2.26-1.6,3.58-2.09h-.01Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,12v-2h-4v-3h-2v3h-2c-1.103,0-2,.897-2,2v3c0,1.103.897,2,2,2h6v3h-8v2h4v3h2v-3h2c1.103,0,2-.8975,2-2v-3c0-1.103-.897-2-2-2h-6v-3h8Z"
  })), children);
})));
if (false) {}
const PricingContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PricingContainer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,2h-5v2h5v24h-5v2h5c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23,20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71,0-2.39,2.51-3.24,4.65-3.24,2.32,0,4.14.86,5.57,2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6,2.26-6,5.22,0,4.73,3.83,5.26,6.91,5.69,3.25.45,5.09.84,5.09,3.58,0,3.03-3.13,3.48-5,3.48-3.43,0-4.88-.96-6.22-2.63l-1.56,1.26c1.77,2.19,3.73,3.17,6.78,3.34v3.04h2v-3.04c3.73-.3,6-2.33,6-5.44Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4,4h5V2H4c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h5v-2H4V4Z"
  })), children);
})));
if (false) {}
const PricingQuickProposal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PricingQuickProposal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29,20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71,0-2.39,2.51-3.24,4.65-3.24,2.32,0,4.14.86,5.57,2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6,2.26-6,5.22,0,4.73,3.83,5.26,6.91,5.69,3.25.45,5.09.84,5.09,3.58,0,3.03-3.13,3.48-5,3.48-3.43,0-4.88-.96-6.22-2.63l-1.56,1.26c1.77,2.19,3.73,3.17,6.78,3.34v3.04h2v-3.04c3.73-.3,6-2.33,6-5.44Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M3 11H11V13H3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M3 19H11V21H3z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M5 15H13V17H5z"
  })), children);
})));
if (false) {}
const PricingTailored = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PricingTailored({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,21h-2c0-2.8226,0-7.0881-10.0903-8.0042l.1807-1.9917c11.9097,1.0811,11.9097,6.8802,11.9097,9.9958Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16.9097,20.9958c-11.9097-1.0811-11.9097-6.8802-11.9097-9.9958h2c0,2.8226,0,7.0881,10.0903,8.0042l-.1807,1.9917Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23,20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71,0-2.39,2.51-3.24,4.65-3.24,2.32,0,4.14.86,5.57,2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6,2.26-6,5.22,0,4.73,3.83,5.26,6.91,5.69,3.25.45,5.09.84,5.09,3.58,0,3.03-3.13,3.48-5,3.48-3.43,0-4.88-.96-6.22-2.63l-1.56,1.26c1.77,2.19,3.73,3.17,6.78,3.34v3.04h2v-3.04c3.73-.3,6-2.33,6-5.44Z"
  })), children);
})));
if (false) {}
const PricingTraditional = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PricingTraditional({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17,15.0698v-6.9536c1.6909.2793,3.084,1.1021,4.2219,2.5117l1.5562-1.2559c-1.5195-1.8823-3.4619-2.9736-5.7781-3.2759v-3.0962h-2v3.022c-3.6152.2192-6,2.2603-6,5.2202,0,4.2739,3.1265,5.1191,6,5.5586v7.1616c-2.7192-.1777-4.0186-1.1001-5.2219-2.5903l-1.5562,1.2559c1.7703,2.1934,3.7332,3.168,6.7781,3.3369v3.0352h2v-3.0449c3.7256-.3042,6-2.3271,6-5.4399,0-4.209-3.1428-5.0156-6-5.4453Zm-6-3.8276c0-2.1533,2.0293-3.0537,4-3.2134v6.7466c-2.5696-.4238-4-1.043-4-3.5332Zm6,12.71v-6.8574c2.5669.4155,4,1.0044,4,3.4204,0,2.5361-2.1902,3.2656-4,3.437Z"
  })), children);
})));
if (false) {}
const Printer = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Printer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
  })), children);
})));
if (false) {}
const PrivateNetwork = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PrivateNetwork({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23v3h-14.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5h.5v-2h-.5c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5h14.5v3h8v-8h-8ZM29,29h-4v-4h4v4ZM23.5,4h-14.5V1H1v8h8v-3h14.5c2.5,0,4.5,2,4.5,4.5s-2,4.5-4.5,4.5h-.5v2h.5c3.6,0,6.5-2.9,6.5-6.5s-2.9-6.5-6.5-6.5ZM7,7H3V3h4v4ZM20,15h-1v-2c0-1.7-1.3-3-3-3s-3,1.3-3,3v2h-1c-.6,0-1,.4-1,1v5c0,.6.4,1,1,1h8c.6,0,1-.4,1-1v-5c0-.6-.4-1-1-1ZM15,13c0-.6.4-1,1-1s1,.4,1,1v2h-2v-2ZM19,20h-6v-3h6v3Z"
  })), children);
})));
if (false) {}
const Process = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Process({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m12,25c-.7383,0-1.3762.4048-1.7227,1h-5.6301l2.6479-5.0923c.2273.0552.4609.0923.7048.0923,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3-3,1.3457-3,3c0,.6787.2349,1.2979.6162,1.8013l-3.5034,6.7373c-.1611.3101-.1489.6816.0325.9805.1812.2983.5054.481.8547.481h7.2773c.3464.5952.9844,1,1.7227,1,1.1045,0,2-.8955,2-2s-.8955-2-2-2Zm-4-8c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m29.8872,26.5386l-4.041-7.771c.0986-.2363.1538-.4956.1538-.7676,0-1.1045-.8955-2-2-2s-2,.8955-2,2,.8955,2,2,2c.0757,0,.1477-.0142.2212-.0225l3.1316,6.0225h-4.5371c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h6.1843c.3494,0,.6736-.1826.8547-.481.1814-.2988.1936-.6704.0325-.9805Zm-9.8872,1.4614c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "m21,8c-.2439,0-.4778.0371-.7048.0923l-3.408-6.5537c-.1721-.3311-.5298-.5386-.8872-.5386s-.7151.2075-.8872.5386l-3.8914,7.4839c-.0737-.0083-.1458-.0225-.2214-.0225-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.272-.0552-.5312-.1538-.7676l3.1538-6.0649,2.6162,5.0312c-.3813.5034-.6162,1.1226-.6162,1.8013,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3Zm0,4c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
})));
if (false) {}
const ProcessAutomate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ProcessAutomate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "m31,17c0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,1.3018.8384,2.4014,2,2.8154v2.6104l-11,6.4165-10.0154-5.8423,22.5193-13.1362c.3071-.1792.4961-.5083.4961-.8638s-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362s-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5083-.4961.8638v3.1846c-1.1616.4141-2,1.5137-2,2.8154,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-1.3018-.8384-2.4014-2-2.8159v-2.6099l11-6.4165,10.0154,5.8423L3.4961,22.1362c-.3071.1792-.4961.5083-.4961.8638s.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l12-7c.3071-.1792.4961-.5083.4961-.8638v-3.1841c1.1616-.4146,2-1.5142,2-2.8159Zm-27-1c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm24,2c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
})));
if (false) {}
const Product = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Product({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H14V20H8z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H18V24H8z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
  })), children);
})));
if (false) {}
const ProgressBar = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ProgressBar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), children);
})));
if (false) {}
const ProgressBarRound = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ProgressBarRound({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const Promote = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Promote({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21 17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 19H17.6V21H6.3z",
    transform: "rotate(-45 12 20)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1 C15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6 l3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
  })), children);
})));
if (false) {}
const PromptSession = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PromptSession({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.5859 25 23.5859 25 21 23 21 23 24.4141 25.5859 27 27 25.5859z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m24,31c-3.8599,0-7-3.1401-7-7s3.1401-7,7-7,7,3.1401,7,7-3.1401,7-7,7Zm0-12c-2.7571,0-5,2.2429-5,5s2.2429,5,5,5,5-2.2429,5-5-2.2429-5-5-5Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m28,15h2V5c0-1.103-.8975-2-2-2h-3v2h3v10Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "13",
    r: "2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "13",
    r: "2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m7,23h-3c-1.103,0-2-.8975-2-2V5c0-1.103.897-2,2-2h3v2h-3v16h3v2Z"
  })), children);
})));
if (false) {}
const PromptTemplate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PromptTemplate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5,23c-.8271,0-1.5-.6729-1.5-1.5v-1.5c0-1.1025-.8972-2-2-2h-2v2h2v1.5c0,.98.4072,1.8643,1.0581,2.5-.6509.6357-1.0581,1.52-1.0581,2.5v1.5h-2v2h2c1.1028,0,2-.8975,2-2v-1.5c0-.8271.6729-1.5,1.5-1.5h.5v-2h-.5Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m16,20v1.5c0,.8271-.6729,1.5-1.5,1.5h-.5v2h.5c.8271,0,1.5.6729,1.5,1.5v1.5c0,1.1025.8972,2,2,2h2v-2h-2v-1.5c0-.98-.4072-1.8643-1.0581-2.5.6509-.6357,1.0581-1.52,1.0581-2.5v-1.5h2v-2h-2c-1.1028,0-2,.8975-2,2Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m28,15h2V5c0-1.103-.8975-2-2-2h-3v2h3v10Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "13",
    r: "2"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "13",
    r: "2"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m7,23h-3c-1.103,0-2-.8975-2-2V5c0-1.103.897-2,2-2h3v2h-3v16h3v2Z"
  })), children);
})));
if (false) {}
const PropertyRelationship = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PropertyRelationship({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16 22 24 20.6 22.6 27.2 16 20.6 9.4 22 8z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H20V17H12z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16 10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
  })), children);
})));
if (false) {}
const PullRequest = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PullRequest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m25,22.1421v-13.1421c0-2.2056-1.7944-4-4-4h-4.1719l2.5859-2.5859-1.4141-1.4141-5,5,5,5,1.4141-1.4141-2.5859-2.5859h4.1719c1.1028,0,2,.8975,2,2v13.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4s4-1.7944,4-4c0-1.8584-1.2798-3.4106-3-3.8579Zm-1,5.8579c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4,6c0,1.8584,1.2798,3.4106,3,3.8579v12.2842c-1.7202.447-3,1.9993-3,3.8579,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8586-1.2798-3.4109-3-3.8579v-12.2842c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4Zm6,20c0,1.1025-.897,2-2,2s-2-.8975-2-2c0-1.1025.897-2,2-2s2,.8975,2,2Zm0-20c0,1.103-.897,2-2,2s-2-.897-2-2c0-1.103.897-2,2-2s2,.897,2,2Z"
  })), children);
})));
if (false) {}
const PunctuationCheck = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function PunctuationCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M23,27.1781l-2.59-2.59-1.41,1.4119,4,4,7-7-1.41-1.4119-5.59,5.59ZM14,16h-3v-.1689c0-1.397.7441-2.7114,1.9419-3.4302l1.1416-.6865-1.03-1.7144-1.1404.686c-1.7969,1.0781-2.9131,3.0493-2.9131,5.145v5.1689c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-4c0-.5522-.4478-1-1-1h0ZM22,16h-3v-.1689c0-1.397.7441-2.7114,1.9419-3.4302l1.1416-.6865-1.03-1.7144-1.1404.686c-1.7969,1.0781-2.9131,3.0493-2.9131,5.145v5.1689c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-4c0-.5522-.4478-1-1-1h0ZM12,28h-6c-1.103,0-2-.8975-2-2V6c0-1.103.897-2,2-2h20c1.1025,0,2,.897,2,2v11h-2V6H6v20h6v2Z"
  })), children);
})));
if (false) {}
const Purchase = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Purchase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H16V22H6z"
  })), children);
})));
if (false) {}
const WatsonHealthQcLaunch = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthQcLaunch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M25,22H19a2.0023,2.0023,0,0,1-2-2V10a2.002,2.002,0,0,1,2-2h6v2H19V20h6Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M13,8H9a2.002,2.002,0,0,0-2,2V20a2.0023,2.0023,0,0,0,2,2h1v2a2.0023,2.0023,0,0,0,2,2h2V24H12V22h1a2.0023,2.0023,0,0,0,2-2V10A2.002,2.002,0,0,0,13,8ZM9,20V10h4V20Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
})));
if (false) {}
const Qiskit = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Qiskit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,1C7.729,1,1,7.729,1,16s6.729,15,15,15,15-6.729,15-15S24.271,1,16,1Zm6.5825,20.5c-.5203-.8926-1.4771-1.5-2.5825-1.5-.1821,0-.3586.0225-.532.0537l-1.7258-3.0205c6.7866.2388,10.1216,1.8262,10.2571,2.4668-.0979.4624-1.8899,1.4141-5.4167,2Zm-2.5825.5c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1ZM3,16c0-.5435.0442-1.0762.1094-1.6025.8552.666,2.1555,1.1973,3.7239,1.6025-1.5684.4053-2.8687.9365-3.7239,1.6025-.0652-.5264-.1094-1.0591-.1094-1.6025Zm6.4175-5.4995c.5205.8921,1.4773,1.4995,2.5825,1.4995.1821,0,.3586-.0225.532-.0537l1.7258,3.0205c-6.8042-.2393-10.1387-1.8335-10.2581-2.4619.0862-.4609,1.8784-1.416,5.4177-2.0044Zm2.5825-.5005c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm13.167,6c1.5681-.4053,2.8684-.9365,3.7236-1.6025.0652.5264.1094,1.0591.1094,1.6025s-.0442,1.0762-.1094,1.6025c-.8552-.666-2.1555-1.1973-3.7236-1.6025ZM16,3c4.9019,0,9.1758,2.7285,11.3901,6.7451-2.2891-.9961-5.7993-1.5513-9.3901-1.6997v1.999c6.6108.2695,9.8655,1.8232,9.9993,2.4556-.1431.6763-3.8533,2.4062-11.4236,2.4917l-2.3118-4.0454c.4524-.5254.7361-1.2002.7361-1.9463,0-1.6543-1.3457-3-3-3-1.4956,0-2.7285,1.1035-2.9531,2.5371-1.7056.2837-3.2363.6841-4.4351,1.2051,2.2151-4.0146,6.4878-6.7422,11.3882-6.7422Zm0,26c-4.9019,0-9.1758-2.7285-11.3901-6.7451,2.2891.9961,5.7993,1.5513,9.3901,1.6997v-1.999c-6.6282-.2705-9.8823-1.8306-10.0002-2.4507.126-.6729,3.8357-2.4106,11.4246-2.4966l2.3118,4.0454c-.4524.5254-.7361,1.2002-.7361,1.9463,0,1.6543,1.3457,3,3,3,1.4956,0,2.7285-1.1035,2.9531-2.5371,1.7056-.2837,3.2363-.6841,4.4351-1.2051-2.2151,4.0146-6.4878,6.7422-11.3882,6.7422Z"
  })), children);
})));
if (false) {}
const QqPlot = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QqPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
  })), children);
})));
if (false) {}
const QrCode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QrCode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z",
    transform: "rotate(-90 25 27)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z",
    transform: "rotate(-90 19 23)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30 22 30 22 28 20 28 20 26 18 26 18 30z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H29V25H25z",
    transform: "rotate(-90 27 24)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26 30 26 30 30 26 30 26 28 28 28 28 26z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20 26 18 30 18 30 22 28 22 28 20 26 20z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20 22 20 22 24 20 24 20 26 24 26 24 20z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H21V21H19z",
    transform: "rotate(-90 20 19)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30H2V18H14ZM4,28h8V20H4Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H26V10H22z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H18V2H30ZM20,12h8V4H20Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V10H6z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14H2V2H14ZM4,12h8V4H4Z"
  })), children);
})));
if (false) {}
const QuadrantPlot = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QuadrantPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15 17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M5,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,5,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,5,26Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M8,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,8,8ZM8,4A1,1,0,1,0,9,5,1.001,1.001,0,0,0,8,4Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,22,13Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,22,9Z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "21",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "28",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "24",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "11",
    r: "2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), children);
})));
if (false) {}
const Query = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Query({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "15.5",
    r: "1.5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
  })), children);
})));
if (false) {}
const QueryQueue = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QueryQueue({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H28V14H10z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H28V20H15z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H28V26H10z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14 11 19 4 24 4 14z"
  })), children);
})));
if (false) {}
const QuestionAnswering = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QuestionAnswering({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M20 15.1798 17.41 12.59 16 14 20 18 26 12 24.59 10.59 20 15.1798z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M8 18H10V20H8z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12,9h-5v2h4v2h-3v3h2v-1h2c.5522,0,1-.4478,1-1v-4c0-.5522-.4478-1-1-1Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.7358,30l-1.7358-1,4-7h6c1.1071,0,2-.8926,2-2v-12c0-1.1074-.8929-2-2-2H6c-1.1071,0-2,.8926-2,2v12c0,1.1074.8929,2,2,2h9v2H6c-2.2093,0-4-1.79-4-4v-12c0-2.2109,1.7907-4,4-4h20c2.2093,0,4,1.7891,4,4v12c0,2.21-1.7907,4-4,4h-4.8354l-3.4287,6Z"
  })), children);
})));
if (false) {}
const Queued = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Queued({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H30V22H22z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H30V26H22z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H30V30H22z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H20V26H18z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H20V22H18z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H20V30H18z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8149,8.293A12.0777,12.0777,0,0,1,10.0068,5.62L9.0079,3.89A14.0845,14.0845,0,0,0,5.2841,7.0083Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1851,8.293l1.5308-1.2847A14.0845,14.0845,0,0,0,22.9921,3.89l-.9989,1.73A12.0777,12.0777,0,0,1,25.1851,8.293Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7366,11.9l-1.8772-.6831A13.9019,13.9019,0,0,0,2,16H4A11.917,11.917,0,0,1,4.7366,11.9Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8149,23.707A11.9975,11.9975,0,0,1,4.7366,20.1l-1.8772.6831a13.99,13.99,0,0,0,2.4247,4.209Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2634,11.9A11.917,11.917,0,0,1,28,16h2a13.8971,13.8971,0,0,0-.8594-4.7827Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9182,27.8066A11.8894,11.8894,0,0,1,10.0068,26.38l-.9989,1.73a13.8673,13.8673,0,0,0,4.5633,1.664Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9182,4.1934a11.3012,11.3012,0,0,1,4.1636,0l.347-1.9678a13.187,13.187,0,0,0-4.8576,0Z"
  })), children);
})));
if (false) {}
const Quotes = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Quotes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15H6.11A9,9,0,0,1,10,8.86l1.79-1.2L10.69,6,8.9,7.2A11,11,0,0,0,4,16.35V23a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V17A2,2,0,0,0,12,15Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15H20.11A9,9,0,0,1,24,8.86l1.79-1.2L24.7,6,22.9,7.2A11,11,0,0,0,18,16.35V23a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V17A2,2,0,0,0,26,15Z"
  })), children);
})));
if (false) {}
const Radar = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Radar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
  })), children);
})));
if (false) {}
const RadarEnhanced = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RadarEnhanced({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
  })), children);
})));
if (false) {}
const RadarWeather = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RadarWeather({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
  })), children);
})));
if (false) {}
const Radio = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Radio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M10,26a4,4,0,1,1,4-4A4,4,0,0,1,10,26Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,20Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14H13V16H7z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16H26V18H17z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H26V22H17z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H26V26H17z"
  })), children);
})));
if (false) {}
const RadioCombat = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RadioCombat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M10,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,20Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H26V22H17z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H26V26H17z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
  })), children);
})));
if (false) {}
const RadioPushToTalk = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RadioPushToTalk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H19V13H13z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H19V17H13z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "2"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
  })), children);
})));
if (false) {}
const RadioButton = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RadioButton({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
})));
if (false) {}
const RadioButtonChecked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RadioButtonChecked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
  })), children);
})));
if (false) {}
const Rag = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rag({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12,28h-2c-3.8599,0-7-3.1401-7-7v-2h2v2c0,2.7568,2.2432,5,5,5h2v2Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,19h-9c-1.104.0014-1.9986.896-2,2v5c0,1.1046.8954,2,2,2h3v-2h-3v-5h9v5h-2.5352l-2.5937,3.8906,1.6641,1.1094,2-3h1.4648c1.1046,0,2-.8954,2-2v-5c-.0014-1.104-.896-1.9986-2-2Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29,15v-4c0-3.8599-3.1401-7-7-7h-3v2h3c2.7568,0,5,2.2432,5,5v4h2Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M6 10H9V12H6z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m12.606,6.4355l-2.5251-3.6855c-.3821-.4766-.9512-.75-1.5615-.75h-4.5193c-1.1028,0-2,.8975-2,2v10c0,1.1025.8972,2,2,2h7c1.1028,0,2-.8975,2-2v-6.375c0-.4526-.1558-.8965-.394-1.1895Zm-8.606,7.5645V4h4v3c0,.5522.4478,1,1,1h2v6h-7Z"
  })), children);
})));
if (false) {}
const Rain = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22ZM16,4a7,7,0,0,0-6.94,6.14L9,11,8.14,11a4.5,4.5,0,0,0,.36,9h15a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82A7,7,0,0,0,16,4Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,14,30Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,20,30Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30a.93.93,0,0,1-.45-.11,1,1,0,0,1-.44-1.34l2-4a1,1,0,1,1,1.78.9l-2,4A1,1,0,0,1,8,30Z"
  })), children);
})));
if (false) {}
const RainDrizzle = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RainDrizzle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
})));
if (false) {}




/***/ }),

/***/ 6194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nH": function() { return /* binding */ CloudUpload; }
/* harmony export */ });
/* unused harmony exports ChartMarimekko, ChartMaximum, ChartMedian, ChartMinimum, ChartMultiLine, ChartMultitype, ChartNetwork, ChartParallel, ChartPie, ChartPlanningWaterfall, ChartPoint, ChartPopulation, ChartRadar, ChartRadial, ChartRelationship, ChartRing, ChartRiver, ChartRose, ChartScatter, ChartSpiral, ChartStacked, ChartStepper, ChartSunburst, ChartTSne, ChartTreemap, ChartVennDiagram, ChartViolinPlot, ChartWaterfall, ChartWinLoss, Chat, ChatBot, ChatLaunch, ChatOff, ChatOperational, Checkbox, CheckboxChecked, CheckboxCheckedFilled, CheckboxIndeterminate, CheckboxIndeterminateFilled, Checkmark, CheckmarkFilled, CheckmarkFilledError, CheckmarkFilledWarning, CheckmarkOutline, CheckmarkOutlineError, CheckmarkOutlineWarning, Chemistry, ChemistryReference, ChevronDown, ChevronDownOutline, ChevronLeft, ChevronMini, ChevronRight, ChevronSort, ChevronSortDown, ChevronSortUp, ChevronUp, ChevronUpOutline, ChildNode, Chip, Choices, ChooseItem, ChoroplethMap, CicsCmas, CicsDb2Connection, CicsExplorer, CicsProgram, CicsRegion, CicsRegionAlt, CicsRegionRouting, CicsRegionTarget, CicsSit, CicsSitOverrides, CicsSystemGroup, CicsTransactionServerZos, CicsWuiRegion, Cicsplex, CircleDash, CircleFill, CircleFilled, CircleOutline, CirclePacking, CircleSolid, CircleStroke, ClassicBatch, Classification, ClassifierLanguage, Clean, Close, CloseFilled, CloseLarge, CloseOutline, ClosedCaption, ClosedCaptionAlt, ClosedCaptionFilled, Cloud, CloudAlerting, CloudApp, CloudAuditing, CloudCeiling, CloudDataOps, CloudDownload, CloudFoundry_1, CloudFoundry_2, CloudInfraMigration, CloudLogging, CloudMonitoring, CloudOffline, CloudRegistry, CloudSatellite, CloudSatelliteConfig, CloudSatelliteLink, CloudSatelliteServices, CloudServiceManagement, CloudServices, Cloudy, CobolUpgradeAdvisor, Code, CodeBlock, CodeHide, CodeReference, QCircuitComposer, WatsonHealthCircleMeasurement, WatsonHealthCobbAngle */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _circle2, _circle3, _circle4, _circle5, _path24, _path25, _path26, _path27, _path28, _circle6, _circle7, _circle8, _path29, _circle9, _circle0, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _circle1, _circle10, _circle11, _circle12, _circle13, _path43, _path44, _path45, _path46, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _circle28, _circle29, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _circle30, _path166, _path167, _circle31, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _circle32, _path196, _path197, _circle33, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _circle34, _circle35, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _circle36, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _circle37, _path289, _circle38, _path290, _path291, _circle39, _path292, _circle40, _path293, _path294, _path295, _circle41, _path296, _circle42, _path297, _path298, _circle43, _path299, _circle44, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324;
const ChartMarimekko = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartMarimekko({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,7H21V5h6ZM19,8H13V5h6Zm0,2v8H13V10ZM11,22H5V12h6Zm2-2h6v7H13Zm8-8h6v4H21ZM11,5v5H5V5ZM5,24h6v3H5Zm16,3V18h6v9Z"
  })), children);
})));
if (false) {}
const ChartMaximum = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartMaximum({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H10V8H8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H14V8H12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H22V8H20z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H26V8H24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V8H28z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.989,28l-.0271-.1631C26.5105,19.0742,24.0662,9.0894,18,8.0889V6H16V8.085c-6.084.978-8.533,10.9775-9.9863,19.7519L5.9866,28H4V8H6V6H4V2H2V28a2,2,0,0,0,2,2H30V28ZM8.0151,28c2.024-12.1084,4.959-18,8.9727-18s6.9487,5.8916,8.9726,18Z"
  })), children);
})));
if (false) {}
const ChartMedian = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartMedian({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H18V24H16z",
    transform: "rotate(-90 17 23)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28V26H16v2H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0532,19.6787A3.44,3.44,0,0,1,23,22c-2.17,0-3.3115-3.333-4.52-6.8623-.3557-1.0386-.7239-2.1094-1.1382-3.1377H18V10H16.4221C15.2124,7.7148,13.5811,6,11,6,7.3218,6,6.1016,9.5332,6.0513,9.6836l1.8955.6377A3.44,3.44,0,0,1,11,8c2.92,0,4.2764,3.958,5.5874,7.7861.2544.7422.5105,1.4893.7813,2.2139H16v2h2.2019c1.0828,2.2886,2.4959,4,4.7981,4,3.6782,0,4.8984-3.5332,4.9487-3.6836Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H18V8H16z",
    transform: "rotate(-90 17 7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H18V4H16z",
    transform: "rotate(-90 17 3)"
  })), children);
})));
if (false) {}
const ChartMinimum = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartMinimum({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28V26H6V24H4V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H10V26H8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H14V26H12z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H22V26H20z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H26V26H24z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24H30V26H28z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9463,4.3281,25.9727,4C23.9487,16.1084,21.0137,22,17,22S10.0513,16.1084,8.0271,4l-1.9734.3281C7.51,13.0566,9.9631,22.93,16,23.9131V26h2V23.9131C24.0371,22.93,26.4907,13.0566,27.9463,4.3281Z"
  })), children);
})));
if (false) {}
const ChartMultiLine = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartMultiLine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5859,28l7.1783-5.998L19.7578,23.94a2.021,2.021,0,0,0,1.314-.1206L28,20.5811l-.8479-1.8121-6.9163,3.229L12.2422,20.06a2.0033,2.0033,0,0,0-1.74.3838L4,25.8818V20.49l7.7642-6.4877L19.7578,15.94a2.021,2.021,0,0,0,1.314-.1206l6.9287-3.2383-.8467-1.812-6.918,3.2285L12.2422,12.06a2.0049,2.0049,0,0,0-1.74.3838L4,17.8818V12.49L11.7642,6.002,19.7578,7.94a2.021,2.021,0,0,0,1.314-.1206L28,4.5859l-.8457-1.8115L20.2358,5.998,12.2422,4.06a2.0033,2.0033,0,0,0-1.74.3838L4,9.8818V2H2V28a2,2,0,0,0,2,2H30V28Z"
  })), children);
})));
if (false) {}
const ChartMultitype = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartMultitype({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22H30V30H28z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18H26V30H24z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H22V30H20z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16a7,7,0,1,0,7,7A7.0078,7.0078,0,0,0,9,16Zm4.8989,6H10V18.1011A5.0145,5.0145,0,0,1,13.8989,22ZM9,28a5,5,0,0,1-1-9.8989V22a2,2,0,0,0,2,2h3.8989A5.0081,5.0081,0,0,1,9,28Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5352,12l4-6H30V4H25.4648l-4,6H18V2H16V14a2,2,0,0,0,2,2H30V14H18V12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "11",
    r: "1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "5",
    r: "1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "9",
    r: "1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "13",
    r: "1"
  })), children);
})));
if (false) {}
const ChartNetwork = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartNetwork({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2v4.1A5,5,0,0,0,18.1,22H14V20a2,2,0,0,0-2-2H10V13.9a5,5,0,1,0-2,0V18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V24h4.1A5,5,0,1,0,24,18.1V14ZM6,9a3,3,0,1,1,3,3A3,3,0,0,1,6,9Zm6,17H6V20h6Zm14-3a3,3,0,1,1-3-3A3,3,0,0,1,26,23ZM20,6h6v6H20Z"
  })), children);
})));
if (false) {}
const ChartParallel = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartParallel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2V5.3071l-6,2.25V2H20V7.5229l-8-3.2V2H10V4.4458l-6,3.75V2H2V30H4V27.6182l6-3V30h2V24.3442l8,2.4V30h2V26.5542l6-3.75V30h2V2Zm0,5.4429V12.5L22,17V9.6929ZM20,9.6768v7.5571l-8-4.8V6.4771ZM10,6.8042v5.7417l-6,5.25V10.5542ZM4,25.3818V20.4541l6-5.25v7.1777Zm8-3.1259v-7.49l8,4.8v5.0894Zm10,1.94V19.5L28,15v5.4458Z"
  })), children);
})));
if (false) {}
const ChartPie = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartPie({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4ZM26,15H17V6.05A10,10,0,0,1,26,15ZM15.42,26A10,10,0,0,1,15,6.05v9a2,2,0,0,0,2,2h9A10,10,0,0,1,15.42,26Z"
  })), children);
})));
if (false) {}
const ChartPlanningWaterfall = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartPlanningWaterfall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m29,8c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v7h-2V3c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v12h-2V5c0-.5522-.4478-1-1-1h-4c-.5522,0-1,.4478-1,1v10H3v12c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-10h2v5c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-5h2v12c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-12h4v-9ZM7,26h-2v-9h2v9Zm8-5h-2v-4h2v4Zm2-6V4h2v11h-2Zm10,0h-2v-6h2v6Z"
  })), children);
})));
if (false) {}
const ChartPoint = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartPoint({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2.0023,2.0023,0,0,1-2-2V2H4V28H30Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "22",
    r: "3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "14",
    r: "3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,9,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,9,13Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "6",
    r: "3"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "22",
    r: "3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,27,17Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,27,13Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,18,26Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,18,22Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,18,8Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,18,4Z"
  })), children);
})));
if (false) {}
const ChartPopulation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartPopulation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22H17V20h9V14H17V12h5V6H17V2H15V6H10v6h5v2H6v6h9v2H2v6H15v2h2V28H30ZM20,8v2H17V8Zm-8,2V8h3v2Zm12,6v2H17V16ZM8,18V16h7v2ZM4,26V24H15v2Zm24,0H17V24H28Z"
  })), children);
})));
if (false) {}
const ChartRadar = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartRadar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2,2,13,8,30H24l6-17Zm2.5818,19.2651-5.9861,1.3306-1.4226-7.8252,4.91-4.209,5.4416,4.0816Zm.1977,2.0054L21.3264,28H10.6736l1.7912-3.3267ZM9.59,13.4937,5.74,12.605,15,5.3291V8.8569ZM17,8.75V5.3291l9.26,7.2759-3.15.727ZM4.6143,14.3979l4.6535,1.0738,1.4844,8.164-1.738,3.2281ZM22.9858,26.8638l-2.5766-4.7852,3.0063-6.7646,3.97-.9161Z"
  })), children);
})));
if (false) {}
const ChartRadial = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartRadial({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26A10.0115,10.0115,0,0,1,6,16H8a8,8,0,1,0,8-8V6a10,10,0,0,1,0,20Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6.0069,6.0069,0,0,1-6-6h2a4,4,0,1,0,4-4V10a6,6,0,0,1,0,12Z"
  })), children);
})));
if (false) {}
const ChartRelationship = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartRelationship({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6a3.9963,3.9963,0,0,0-3.8579,3H17.9305A7.9964,7.9964,0,1,0,9,17.9307v4.2114a4,4,0,1,0,2,0V17.9307a7.951,7.951,0,0,0,3.8976-1.6192l3.6693,3.67A3.9529,3.9529,0,0,0,18,22a4,4,0,1,0,4-4,3.9521,3.9521,0,0,0-2.019.5669l-3.6694-3.6694A7.9493,7.9493,0,0,0,17.9305,11h4.2116A3.9934,3.9934,0,1,0,26,6ZM12,26a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,12,26ZM10,16a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,10,16Zm14,6a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,24,22Zm2-10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,12Z"
  })), children);
})));
if (false) {}
const ChartRing = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartRing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM27.9493,15.001H21.91a5.9825,5.9825,0,0,0-9.3806-3.8853l-4.27-4.27a11.9783,11.9783,0,0,1,19.69,8.1548ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20ZM4,16A11.937,11.937,0,0,1,6.8455,8.26l4.27,4.2695A5.9836,5.9836,0,0,0,15,21.9106v6.04A12.0105,12.0105,0,0,1,4,16ZM17,27.95v-6.04A6.0069,6.0069,0,0,0,21.91,17h6.04A12.0082,12.0082,0,0,1,17,27.95Z"
  })), children);
})));
if (false) {}
const ChartRiver = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartRiver({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4326,20.0171l8.0376,4.68a1.958,1.958,0,0,0,1.0508.3012,2.2412,2.2412,0,0,0,.4888-.0556l7.2532-1.9769A1,1,0,0,0,30,22.0007V7.996A1,1,0,0,0,28.74,7.0305L21.5034,8.9829l-8.0371-4.68a1.9917,1.9917,0,0,0-1.8652-.1352L4,7.4727V2H2V28a2,2,0,0,0,2,2H30V28H4V23.6577ZM28,21.2344l-6.4966,1.75-8.0371-4.68a1.9931,1.9931,0,0,0-1.8652-.1353L4,21.4746V16.6572l8.4326-3.6416L20.47,17.6968a1.962,1.962,0,0,0,1.0508.3008,2.2112,2.2112,0,0,0,.4888-.0557L28,16.31ZM12.4326,6.0156l8.0376,4.68a2.0091,2.0091,0,0,0,1.54.2451L28,9.3081v4.9258l-6.4966,1.7505-8.0371-4.6812a1.9917,1.9917,0,0,0-1.8652-.1352L4,14.4736V9.6562Z"
  })), children);
})));
if (false) {}
const ChartRose = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartRose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17A15.017,15.017,0,0,0,15,2H14V8.0591A9.0122,9.0122,0,0,0,6.0591,16H4v1A11.0109,11.0109,0,0,0,14,27.9492V30h1A13.0084,13.0084,0,0,0,27.9492,18H30ZM16,4.0381A13.0217,13.0217,0,0,1,27.9619,16H16ZM14,10.08V16H8.08A7.0037,7.0037,0,0,1,14,10.08ZM6.0552,18H14v7.939A9.0134,9.0134,0,0,1,6.0552,18ZM16,27.9551V18h9.9551A11.0191,11.0191,0,0,1,16,27.9551Z"
  })), children);
})));
if (false) {}
const ChartScatter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartScatter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "22",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "15",
    r: "2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "15",
    r: "2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "6",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "8",
    r: "2"
  })), children);
})));
if (false) {}
const ChartSpiral = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartSpiral({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.919,13.919,0,0,0,7.3245,5.0327,1.9728,1.9728,0,0,0,7,5,2,2,0,0,0,5,7a1.9752,1.9752,0,0,0,.0327.3247A13.986,13.986,0,1,0,16,2Zm0,26A11.977,11.977,0,0,1,6.3589,8.8857a1.8311,1.8311,0,0,0,1.1528.04l1.4634,1.4634a8.9862,8.9862,0,0,0,11.8311,13.207,1.9916,1.9916,0,0,0,2.79-2.79,8.9294,8.9294,0,0,0,0-9.6124,1.9916,1.9916,0,0,0-2.79-2.79,8.9445,8.9445,0,0,0-10.417.5713L8.9258,7.5117a1.8294,1.8294,0,0,0-.04-1.1528A11.9925,11.9925,0,1,1,16,28Zm0-14a2,2,0,1,1-2,2A2.0025,2.0025,0,0,1,16,14Zm3.4331-.019,2.0552-2.0552a2.0443,2.0443,0,0,0,.2265.0454,6.9573,6.9573,0,0,1,0,8.0576,2.0443,2.0443,0,0,0-.2265.0454L19.4331,18.019a3.8788,3.8788,0,0,0,0-4.038Zm.5957-3.6958a1.9993,1.9993,0,0,0,.0454.2265L18.019,12.5669a3.8788,3.8788,0,0,0-4.038,0l-2.1653-2.1655a6.9522,6.9522,0,0,1,8.2131-.1162ZM12.5669,13.981A3.951,3.951,0,0,0,12,16a4.0045,4.0045,0,0,0,4,4,3.9521,3.9521,0,0,0,2.019-.5669l2.0552,2.0552a1.9993,1.9993,0,0,0-.0454.2265,6.988,6.988,0,0,1-9.6272-9.8994Z"
  })), children);
})));
if (false) {}
const ChartStacked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartStacked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28V6H20V28H16V14H8V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM22,8h4V18H22ZM10,16h4v6H10Z"
  })), children);
})));
if (false) {}
const ChartStepper = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartStepper({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14,22V14h8V6h8V4H20v8H12v8H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V22Z"
  })), children);
})));
if (false) {}
const ChartSunburst = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartSunburst({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a1,1,0,0,0-1,1v7.09a5.9618,5.9618,0,0,0-2.46,1.043L7.8384,6.4311a1.4554,1.4554,0,0,0-2.087.0244A14.05,14.05,0,0,0,9.8047,28.5972a10.8482,10.8482,0,0,0,1.8989.7676,14.0982,14.0982,0,0,0,13.8443-3.1319,1.4336,1.4336,0,0,0,.0278-2.0639L20.877,19.47A5.963,5.963,0,0,0,21.91,17H29a1,1,0,0,0,1-1A14.0158,14.0158,0,0,0,16,2Zm0,10a4,4,0,1,1-4,4A4.0045,4.0045,0,0,1,16,12ZM6.83,8.251l4.2959,4.2959a5.91,5.91,0,0,0-.0113,6.9243L6.8381,23.7481A12.0168,12.0168,0,0,1,6.83,8.251Zm1.4228,16.91,4.2759-4.2759A5.9589,5.9589,0,0,0,15,21.91v6.042A11.8783,11.8783,0,0,1,8.2529,25.1612ZM17,27.9561V21.9092a5.9631,5.9631,0,0,0,2.4609-1.0273l4.2818,4.2817A11.8905,11.8905,0,0,1,17,27.9561ZM21.91,15A6.0063,6.0063,0,0,0,17,10.09V4.041A12.0208,12.0208,0,0,1,27.9585,15Z"
  })), children);
})));
if (false) {}
const ChartTSne = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartTSne({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "20",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "14",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "6",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "10",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "12",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "22",
    r: "2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "28",
    r: "2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "26",
    r: "2"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "20",
    r: "2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "24",
    r: "2"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), children);
})));
if (false) {}
const ChartTreemap = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartTreemap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,12H23V4h5ZM16,4h5V14H16ZM14,4V20H4V4ZM4,22H14v6H4Zm12,6V16H28V28Z"
  })), children);
})));
if (false) {}
const ChartVennDiagram = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartVennDiagram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6a9.92,9.92,0,0,0-4,.84A9.92,9.92,0,0,0,12,6a10,10,0,0,0,0,20,9.92,9.92,0,0,0,4-.84A9.92,9.92,0,0,0,20,26,10,10,0,0,0,20,6ZM12,24A8,8,0,0,1,12,8a7.91,7.91,0,0,1,1.76.2,10,10,0,0,0,0,15.6A7.91,7.91,0,0,1,12,24Zm8-8a8,8,0,0,1-4,6.92A8,8,0,0,1,16,9.08,8,8,0,0,1,20,16Zm0,8a7.91,7.91,0,0,1-1.76-.2,10,10,0,0,0,0-15.6A7.91,7.91,0,0,1,20,8a8,8,0,0,1,0,16Z"
  })), children);
})));
if (false) {}
const ChartViolinPlot = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartViolinPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H4a2,2,0,0,1-2-2V2H4V28H30Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.86,7.8232,13,4.7231V2H11V4.7231l-1.86,3.1A7.9986,7.9986,0,0,0,8,11.939v.122a7.9961,7.9961,0,0,0,1.14,4.1158l1.86,3.1V26h2V19.2769l1.86-3.1A7.9986,7.9986,0,0,0,16,12.061v-.122A7.9961,7.9961,0,0,0,14.86,7.8232ZM12,6.9434l1.145,1.9087A6.0027,6.0027,0,0,1,13.9185,11h-3.837a6.0086,6.0086,0,0,1,.7735-2.1484Zm0,10.1132-1.145-1.9087A6.0027,6.0027,0,0,1,10.0815,13h3.837a6.0086,6.0086,0,0,1-.7735,2.1484Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M27.86,11.8232,26,8.7231V2H24V8.7231l-1.86,3.1A7.9986,7.9986,0,0,0,21,15.939v.122a7.9961,7.9961,0,0,0,1.14,4.1158l1.86,3.1V26h2V23.2769l1.86-3.1A7.9986,7.9986,0,0,0,29,16.061v-.122A7.9961,7.9961,0,0,0,27.86,11.8232Zm-2.86-.88,1.145,1.9087A6.0027,6.0027,0,0,1,26.9185,15h-3.837a6.0086,6.0086,0,0,1,.7735-2.1484Zm0,10.1132-1.145-1.9087A6.0027,6.0027,0,0,1,23.0815,17h3.837a6.0086,6.0086,0,0,1-.7735,2.1484Z"
  })), children);
})));
if (false) {}
const ChartWaterfall = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartWaterfall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28V18H26V28H22V4H20V28H10V14H8V28H4V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H16V18H14z"
  })), children);
})));
if (false) {}
const ChartWinLoss = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChartWinLoss({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H16V6a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,6v9H2v2H16v9a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V17h2ZM6,6h8v9H6ZM26,26H18V17h8Z"
  })), children);
})));
if (false) {}
const Chat = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Chat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H24V12H8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  })), children);
})));
if (false) {}
const ChatLaunch = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChatLaunch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4 22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v4a1.9965,1.9965,0,0,1-2,2H20l-4,7,1.7358,1,3.4288-6H26a3.9992,3.9992,0,0,0,4-4V16Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4,20V8A1.9965,1.9965,0,0,1,6,6H18V4H6A3.9986,3.9986,0,0,0,2,8V20a3.9992,3.9992,0,0,0,4,4h9V22H6A1.9965,1.9965,0,0,1,4,20Z"
  })), children);
})));
if (false) {}
const ChatOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChatOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8V21h2V8a3.9986,3.9986,0,0,0-4-4H8.2429l2,2H26A1.9965,1.9965,0,0,1,28,8Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.5859,3.4141,2,2,3.4141,3.5039,4.918A3.9181,3.9181,0,0,0,2,8V20a3.9992,3.9992,0,0,0,4,4h6V22H6a1.9965,1.9965,0,0,1-2-2V8a1.9814,1.9814,0,0,1,.9194-1.6665L20.5859,22H17l-4,7,1.7358,1,3.4288-6h4.4213l6,6Z"
  })), children);
})));
if (false) {}
const ChatOperational = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChatOperational({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M15.586 10.414 19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20.586 10.414 24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9 11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
})));
if (false) {}
const ChatBot = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChatBot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16,19a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,16,19Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,20,8Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,12,8Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
})));
if (false) {}
const Checkbox = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Checkbox({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
})));
if (false) {}
const CheckboxChecked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckboxChecked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.5 9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
  })), children);
})));
if (false) {}
const CheckboxCheckedFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckboxCheckedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const CheckboxIndeterminate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckboxIndeterminate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H22V18H10z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
})));
if (false) {}
const CheckboxIndeterminateFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckboxIndeterminateFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,18H10V14H22Z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const Checkmark = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Checkmark({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
      d: "M8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
    })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
      d: "M15.6 5.6 8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
      d: "M10 15.9 4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24 4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
  })), children);
})));
if (false) {}
const CheckmarkFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckmarkFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
    })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
      d: "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"
    })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"
    })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14 21.591 9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const CheckmarkFilledError = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckmarkFilledError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12 18.591 8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const CheckmarkFilledWarning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckmarkFilledWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12 18.591 8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const CheckmarkOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckmarkOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.414 9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
})));
if (false) {}
const CheckmarkOutlineError = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckmarkOutlineError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.59 9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), children);
})));
if (false) {}
const CheckmarkOutlineWarning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CheckmarkOutlineWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.59 9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), children);
})));
if (false) {}
const Chemistry = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Chemistry({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
  })), children);
})));
if (false) {}
const ChemistryReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChemistryReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
  })), children);
})));
if (false) {}
const ChevronDown = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronDown({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 10 6",
      fill: "currentColor",
      ...rest
    }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
      d: "M5 6 0 1 .7.3 5 4.6 9.3.3 10 1z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
      d: "M8 11 3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22 6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
  })), children);
})));
if (false) {}
const ChevronDownOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronDownOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4142 12.5858 16 19.1714 22.5858 12.5858 24 14 16 22 8 14 9.4142 12.5858z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m30,16c0,7.7197-6.2803,14-14,14S2,23.7197,2,16,8.2803,2,16,2s14,6.2803,14,14Zm-26,0c0,6.6167,5.3833,12,12,12s12-5.3833,12-12-5.3833-12-12-12S4,9.3833,4,16Z"
  })), children);
})));
if (false) {}
const ChevronLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 6 10",
      fill: "currentColor",
      ...rest
    }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
      d: "M0 5 5 0 5.7.7 1.4 5 5.7 9.3 5 10z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
      d: "M5 8 10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16 20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
  })), children);
})));
if (false) {}
const ChevronMini = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronMini({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
      d: "M15 9 15 15 9 15z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19 31 31 19 31 31 19z"
  })), children);
})));
if (false) {}
const ChevronRight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronRight({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 6 10",
      fill: "currentColor",
      ...rest
    }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
      d: "M6 5 1 10 .3 9.3 4.6 5 .3.7 1 0z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
      d: "M11 8 6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16 12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
  })), children);
})));
if (false) {}
const ChevronSort = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronSort({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
      d: "M8 14 4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
    })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
      d: "M8 2 11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28 9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4 23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
  })), children);
})));
if (false) {}
const ChevronSortDown = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronSortDown({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
      d: "M8 14 4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28 9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
  })), children);
})));
if (false) {}
const ChevronSortUp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronSortUp({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
      d: "M8 2 11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4 23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
  })), children);
})));
if (false) {}
const ChevronUp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronUp({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 10 6",
      fill: "currentColor",
      ...rest
    }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
      d: "M5 0 10 5 9.3 5.7 5 1.4.7 5.7 0 5z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
      d: "M8 5 13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10 26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
  })), children);
})));
if (false) {}
const ChevronUpOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChevronUpOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4142 19.4142 16 12.8286 22.5858 19.4142 24 18 16 10 8 18 9.4142 19.4142z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m30,16c0,7.7197-6.2803,14-14,14S2,23.7197,2,16,8.2803,2,16,2s14,6.2803,14,14Zm-26,0c0,6.6167,5.3833,12,12,12s12-5.3833,12-12-5.3833-12-12-12S4,9.3833,4,16Z"
  })), children);
})));
if (false) {}
const ChildNode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChildNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20c-2.41,0-4.43,1.72-4.9,4h-4.1c-2.21,0-4-1.79-4-4v-8.1c2.28-.46,4-2.48,4-4.9,0-2.76-2.24-5-5-5s-5,2.24-5,5c0,2.41,1.72,4.43,4,4.9v8.1c0,3.31,2.69,6,6,6h4.1c.46,2.28,2.48,4,4.9,4,2.76,0,5-2.24,5-5s-2.24-5-5-5ZM6,7c0-1.65,1.35-3,3-3s3,1.35,3,3-1.35,3-3,3-3-1.35-3-3Z"
  })), children);
})));
if (false) {}
const Chip = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Chip({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11V21H21V11Zm8,8H13V13h6Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
  })), children);
})));
if (false) {}
const Choices = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Choices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
  })), children);
})));
if (false) {}
const ChooseItem = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChooseItem({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V26H28z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6 15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
  })), children);
})));
if (false) {}
const ChoroplethMap = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ChoroplethMap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
  })), children);
})));
if (false) {}
const CicsCmas = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsCmas({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3335,30H26V28h4V26H28a2.002,2.002,0,0,1-2-2V21.6665A1.6684,1.6684,0,0,1,27.6665,20H32v2H28v2h2a2.002,2.002,0,0,1,2,2v2.3335A1.6684,1.6684,0,0,1,30.3335,30Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3335,20h-2.667A1.6665,1.6665,0,0,0,18,21.6665V30h2V26h2v4h2V21.6665A1.6665,1.6665,0,0,0,22.3335,20ZM20,24V22h2v2Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24 11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1,22v6.5A1.4727,1.4727,0,0,0,2.5,30H7V28H3V22H7V20H3A2.0059,2.0059,0,0,0,1,22Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
  })), children);
})));
if (false) {}
const CicsDb2Connection = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsDb2Connection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,31c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9348,.364-1.8137,1.0249-2.4749l4.9998-4.9996c.6609-.6613,1.54-1.0255,2.4753-1.0255,1.9299,0,3.5,1.5701,3.5,3.5,0,.9346-.3638,1.8134-1.0244,2.4742l-1.4146-1.4138c.283-.2832,.439-.6598,.439-1.0604,0-.8271-.6729-1.5-1.5-1.5-.4009,0-.7776,.1561-1.061,.4396l-4.9998,4.9998c-.2832,.2833-.4392,.66-.4392,1.0607,0,.8271,.6729,1.5,1.5,1.5,.4011,0,.7783-.1564,1.0618-.4404l1.4155,1.4131c-.6616,.6625-1.5413,1.0273-2.4773,1.0273Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2c-5.2979,0-11,1.252-11,4V24c0,1.6797,2.134,2.7979,5,3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937,.749,3.6738,1.2153,6,1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723,5.2979,0,11-1.252,11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995ZM6.9985,6.0151c.1523-.5552,3.1514-2.0151,9.0015-2.0151,5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8501,0-8.8491-1.46-9.0015-1.9849Zm18.0015,5.9722c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596Z"
  })), children);
})));
if (false) {}
const CicsExplorer = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsExplorer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16 19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const CicsProgram = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsProgram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 19 17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 19 14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "8",
    r: "1"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z"
  })), children);
})));
if (false) {}
const CicsSit = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsSit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22 30 27 23 32 23 22z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z"
  })), children);
})));
if (false) {}
const CicsSitOverrides = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsSitOverrides({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M31.707,20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141,0l-9.293,9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906,.3906-1.0234,0-1.4141Zm-7.4141,6l-2.7073,2.707h-1.5857v-1.5859l2.707-2.707,2.293-2.293,1.5859,1.5859-2.293,2.293Zm3.707-3.707l-1.5859-1.5859,1.5859-1.5859,1.5857,1.5859-1.5857,1.5859Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h4Zm-6-2H4v-7H14v7ZM5,5H25c.5515,0,1,.4482,1,1v3H4v-3c0-.5518,.4485-1,1-1ZM14,27H5c-.5515,0-1-.4482-1-1v-6H14v7Z"
  })), children);
})));
if (false) {}
const CicsSystemGroup = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsSystemGroup({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H23V4h5V28H23v2h5a2.0059,2.0059,0,0,0,2-2V4A2.0059,2.0059,0,0,0,28,2Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M14,17H8a.9448.9448,0,0,0-1,1v6a.9448.9448,0,0,0,1,1h6a.9448.9448,0,0,0,1-1V18A.9448.9448,0,0,0,14,17Zm-1,6H9V19h4Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M25,24V18a.9448.9448,0,0,0-1-1H18a.9448.9448,0,0,0-1,1v6a.9448.9448,0,0,0,1,1h6A1.0021,1.0021,0,0,0,25,24Zm-2-1H19V19h4Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14,7H8A.9448.9448,0,0,0,7,8v6a.9448.9448,0,0,0,1,1h6a.9448.9448,0,0,0,1-1V8A.9448.9448,0,0,0,14,7Zm-1,6H9V9h4Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M18,15h6a.9448.9448,0,0,0,1-1V8a.9448.9448,0,0,0-1-1H18a.9448.9448,0,0,0-1,1v6A1.0021,1.0021,0,0,0,18,15Zm1-6h4v4H19Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
  })), children);
})));
if (false) {}
const CicsTransactionServerZos = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsTransactionServerZos({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "10",
    r: "2"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "22",
    r: "2"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z"
  })), children);
})));
if (false) {}
const CicsWuiRegion = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsWuiRegion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22 24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H16V20H14v8.6A1.4529,1.4529,0,0,0,15.5,30h3A1.4529,1.4529,0,0,0,20,28.6V20H18Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 20 10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
  })), children);
})));
if (false) {}
const CicsRegion = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsRegion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18 21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
})));
if (false) {}
const CicsRegionAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsRegionAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M31,13v-2h-4c-1.1028,0-2,.8975-2,2v2c0,1.1025,.8972,2,2,2h2v2h-4v2h4c1.1028,0,2-.8975,2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M17,13v6c0,1.1025,.8972,2,2,2h4v-2h-4v-6h4v-2h-4c-1.1028,0-2,.8975-2,2Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13 11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1,13v6c0,1.1025,.8972,2,2,2H7v-2H3v-6H7v-2H3c-1.1028,0-2,.8975-2,2Z"
  })), children);
})));
if (false) {}
const CicsRegionRouting = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsRegionRouting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2 22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16 13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
})));
if (false) {}
const CicsRegionTarget = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CicsRegionTarget({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M26 7H28V10H26z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M29 4H32V6H29z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H28V3H26z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H25V6H22z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16 13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
})));
if (false) {}
const Cicsplex = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Cicsplex({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M8,18.6V17H6v1.6A7.3833,7.3833,0,0,0,13.4,26H15V24H13.4A5.3775,5.3775,0,0,1,8,18.6Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18H20a2.0059,2.0059,0,0,0-2,2v8a2.0059,2.0059,0,0,0,2,2h8a2.0059,2.0059,0,0,0,2-2V20A2.0059,2.0059,0,0,0,28,18ZM20,28V20h8v8Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13.4V15h2V13.4A7.3833,7.3833,0,0,0,18.6,6H17V8h1.6A5.3775,5.3775,0,0,1,24,13.4Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M12,2H4A2.0059,2.0059,0,0,0,2,4v8a2.0059,2.0059,0,0,0,2,2h8a2.0059,2.0059,0,0,0,2-2V4A2.0059,2.0059,0,0,0,12,2ZM4,12V4h8v8Z"
  })), children);
})));
if (false) {}
const CircleFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CircleFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "10"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const CircleOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CircleOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-7.732,0-14,6.268-14,14s6.268,14,14,14,14-6.268,14-14S23.732,2,16,2Zm0,26c-6.6274,0-12-5.3726-12-12s5.3726-12,12-12,12,5.3726,12,12-5.3726,12-12,12Z"
  })), children);
})));
if (false) {}
const CircleSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CircleSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14"
  })), children);
})));
if (false) {}
const CircleDash = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CircleDash({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7,4.7a14.7,14.7,0,0,0-3,3.1L6.3,9A13.26,13.26,0,0,1,8.9,6.3Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6,12.3l-1.9-.6A12.51,12.51,0,0,0,2,16H4A11.48,11.48,0,0,1,4.6,12.3Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,20.4a14.4,14.4,0,0,0,2,3.9l1.6-1.2a12.89,12.89,0,0,1-1.7-3.3Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,27.3a14.4,14.4,0,0,0,3.9,2l.6-1.9A12.89,12.89,0,0,1,9,25.7Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,2.7l.6,1.9A11.48,11.48,0,0,1,16,4V2A12.51,12.51,0,0,0,11.7,2.7Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.53,11.53,0,0,1,23,25.7Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4,19.7l1.9.6A15.47,15.47,0,0,0,30,16H28A11.48,11.48,0,0,1,27.4,19.7Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2,11.6a14.4,14.4,0,0,0-2-3.9L25.6,8.9a12.89,12.89,0,0,1,1.7,3.3Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,4.6a14.4,14.4,0,0,0-3.9-2l-.6,1.9a12.89,12.89,0,0,1,3.3,1.7Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,29.3l-.6-1.9A11.48,11.48,0,0,1,16,28v2A21.42,21.42,0,0,0,20.3,29.3Z"
  })), children);
})));
if (false) {}
const CircleFill = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CircleFill({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
      cx: "8",
      cy: "8",
      r: "6"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "6"
  })), children);
})));
if (false) {}
const WatsonHealthCircleMeasurement = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthCircleMeasurement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
  })), children);
})));
if (false) {}
const CirclePacking = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CirclePacking({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
  })), children);
})));
if (false) {}
const CircleStroke = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CircleStroke({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
      d: "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
  })), children);
})));
if (false) {}
const QCircuitComposer = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QCircuitComposer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9 18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
  })), children);
})));
if (false) {}
const ClassicBatch = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ClassicBatch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4v16c0,1.1-.9,2-2,2H12c-1.1,0-2-.9-2-2V4c0-1.1.9-2,2-2h16c1.1,0,2,.9,2,2ZM28,20V4H12v16h16ZM8,6h-2v18c0,1.1.9,2,2,2h18v-2H8V6ZM4,10h-2v18c0,1.1.9,2,2,2h18v-2H4V10Z"
  })), children);
})));
if (false) {}
const Classification = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Classification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "19",
    r: "1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
  })), children);
})));
if (false) {}
const ClassifierLanguage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ClassifierLanguage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V2H22v8h3v4H23v2h7V14H27V10ZM24,4h4V8H24Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.41 18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14 12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M7,9.86a4,4,0,1,0-2,0V14H2v2H9V14H7ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6Z"
  })), children);
})));
if (false) {}
const Clean = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Clean({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H26V20H20z",
    transform: "matrix(-1 0 0 -1 46 38)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H30V28H24z",
    transform: "matrix(-1 0 0 -1 54 54)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H28V24H22z",
    transform: "matrix(-1 0 0 -1 50 46)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
  })), children);
})));
if (false) {}
const Close = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Close({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 16 24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"
  })), children);
})));
if (false) {}
const CloseFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2 l2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9 l5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
})));
if (false) {}
const CloseLarge = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloseLarge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 16 26 7.4141 24.5859 6 16 14.5859 7.4143 6 6 7.4141 14.5859 16 6 24.5859 7.4143 26 16 17.4141 24.5859 26 26 24.5859 17.4141 16z"
  })), children);
})));
if (false) {}
const CloseOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloseOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12 S22.6,28,16,28z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23 16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), children);
})));
if (false) {}
const ClosedCaption = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ClosedCaption({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M15,21H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5v2H10v6h5Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M25,21H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5v2H20v6h5Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
})));
if (false) {}
const ClosedCaptionAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ClosedCaptionAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H25V19H19z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H17V19H11z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H9V19H6z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H26V15H22z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H20V15H13z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H11V15H6z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
})));
if (false) {}
const ClosedCaptionFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ClosedCaptionFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
  })), children);
})));
if (false) {}
const Cloud = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Cloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), children);
})));
if (false) {}
const CloudAlerting = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudAlerting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
  })), children);
})));
if (false) {}
const CloudAuditing = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudAuditing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15 16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
  })), children);
})));
if (false) {}
const CloudDataOps = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudDataOps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H30V28H28z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26V28H24z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H22V28H20z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M22.175,10,23.76,8.7339A9.9522,9.9522,0,0,0,17.89,5.1816,10.0025,10.0025,0,0,0,6.17,13.1152,7.5054,7.5054,0,0,0,.0544,21.4087,7.6843,7.6843,0,0,0,7.7692,28H16V26H7.6945a5.632,5.632,0,0,1-5.6023-4.4858,5.5064,5.5064,0,0,1,4.4339-6.4307l1.3486-.2441.2139-1.11a8.206,8.206,0,0,1,6.7426-6.6426,7.9666,7.9666,0,0,1,3.0137.13A7.8037,7.8037,0,0,1,22.175,10Z"
  })), children);
})));
if (false) {}
const CloudDownload = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudDownload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.17 17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
  })), children);
})));
if (false) {}
const CloudInfraMigration = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudInfraMigration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25,14c-2.34,0-4.25-1.91-4.25-4.25,0-1.79,1.14-3.38,2.78-3.99.74-2.21,2.84-3.76,5.22-3.76s4.48,1.55,5.22,3.76c1.65.61,2.78,2.19,2.78,3.99,0,2.29-1.86,4.19-4.14,4.25h-7.61ZM23,4c-1.64,0-3.08,1.17-3.42,2.77l-.14.64-.64.13c-1.04.21-1.8,1.14-1.8,2.2,0,1.24,1.01,2.26,2.25,2.26h7.58c1.18-.03,2.17-1.05,2.17-2.26,0-1.06-.76-1.99-1.8-2.2l-.64-.13-.14-.64c-.34-1.6-1.78-2.77-3.42-2.77ZM9,16H3c-1.1,0-2,.9-2,2v10c0,1.1.9,2,2,2h6c1.1,0,2-.9,2-2v-10c0-1.1-.9-2-2-2ZM9,18v2H3v-2h6ZM9,22v2H3v-2h6ZM3,28v-2h6v2H3ZM21.47,22h-4.45l2.58-2.77-1.41-1.41-5.18,5.18,5.16,5.21,1.42-1.41-2.58-2.79h4.47c1.4,0,2.53-1.13,2.53-2.53v-5.47h-2v5.47c0,.29-.23.53-.53.53h0l-.01-.01Z"
  })), children);
})));
if (false) {}
const CloudLogging = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudLogging({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H30V6H18z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H30V10H18z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H24V14H18z"
  })), children);
})));
if (false) {}
const CloudMonitoring = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudMonitoring({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
  })), children);
})));
if (false) {}
const CloudOffline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudOffline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,12.1362a8.8694,8.8694,0,0,0-.9795-2.5434L30,3.4142,28.5872,2,2,28.5872,3.4142,30l5-5H23.5a6.4974,6.4974,0,0,0,1.3008-12.8638ZM23.5,23H10.4141L22.3418,11.0723a6.9049,6.9049,0,0,1,.6006,2.0708l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,23Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2964,23.4487l1.4313-1.4311A4.4774,4.4774,0,0,1,8.144,14.019l.8155-.0639.0991-.812a6.9867,6.9867,0,0,1,10.63-5.0865l1.4431-1.4428A8.9859,8.9859,0,0,0,7.2,12.1362,6.4891,6.4891,0,0,0,4.2964,23.4487Z"
  })), children);
})));
if (false) {}
const CloudServiceManagement = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudServiceManagement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), children);
})));
if (false) {}
const CloudUpload = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CloudUpload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11 18 12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
  })), _path266 || (_path266 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), children);
});
if (false) {}
const CloudApp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudApp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8289,13.1155A10.02,10.02,0,0,0,16,5.0005V7a8.0233,8.0233,0,0,1,7.8649,6.4934l.2591,1.346,1.3488.2441A5.5019,5.5019,0,0,1,24.5076,26H16v2h8.5076a7.5019,7.5019,0,0,0,1.3213-14.8845Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H14V26H8z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H6V26H4z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H14V22H6z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20H4V22H2z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H14V18H8z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H6V18H4z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H14V14H10z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8V14H6z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H14V10H12z"
  })), children);
})));
if (false) {}
const CloudCeiling = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudCeiling({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H11V30H2z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28H30V30H21z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.167 17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
  })), children);
})));
if (false) {}
const CloudFoundry_1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudFoundry_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24H11a2,2,0,0,1-2-2V19a2,2,0,0,1,2-2h3v2H11v3h3Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M21,15V13H19a2,2,0,0,0-2,2v2H16v2h1v5h2V19h2V17H19V15Z"
  })), children);
})));
if (false) {}
const CloudFoundry_2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudFoundry_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11 25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h6Z"
  })), children);
})));
if (false) {}
const CloudRegistry = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudRegistry({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H23a2.0023,2.0023,0,0,1-2-2V23a2.0023,2.0023,0,0,1,2-2h5a2.0023,2.0023,0,0,1,2,2v5A2.0023,2.0023,0,0,1,28,30Zm-5-7h-.0012L23,28h5V23Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H11a2.0023,2.0023,0,0,1-2-2V11a2.0023,2.0023,0,0,1,2-2H21a2.0023,2.0023,0,0,1,2,2v5H21V11H11V21h5Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
  })), children);
})));
if (false) {}
const CloudSatellite = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudSatellite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
})));
if (false) {}
const CloudSatelliteConfig = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudSatelliteConfig({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
})));
if (false) {}
const CloudSatelliteLink = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudSatelliteLink({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
  })), children);
})));
if (false) {}
const CloudSatelliteServices = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudSatelliteServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
})));
if (false) {}
const CloudServices = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CloudServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
  })), children);
})));
if (false) {}
const Cloudy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Cloudy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
  })), children);
})));
if (false) {}
const WatsonHealthCobbAngle = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthCobbAngle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17V15a2,2,0,0,0-2-2H10a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h8A2,2,0,0,0,20,17ZM10,15h8v2H10Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M23.42,24.48A2,2,0,0,0,21,23.06l-7.73,2.07a2,2,0,0,0-1.42,2.44h0l.52,1.93A2,2,0,0,0,14.27,31a3,3,0,0,0,.52-.07l7.73-2.07h0a2,2,0,0,0,1.41-2.45ZM14.27,29l-.51-1.94L21.48,25,22,26.92Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M13.24,6.86,21,8.93h0a2.24,2.24,0,0,0,.51.07,2,2,0,0,0,1.94-1.48L24,5.58a2,2,0,0,0-1.41-2.45L14.79,1.06a2,2,0,0,0-2.45,1.41h0l-.52,1.93a2,2,0,0,0,1.42,2.44Zm1-3.86L22,5.07,21.48,7,13.76,4.93Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21H16V23H14z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H16V11H14z"
  })), children);
})));
if (false) {}
const CobolUpgradeAdvisor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CobolUpgradeAdvisor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M25.57,6.4299l-1.46,1.4602-1.68-2.8901h-12.86l-6.41,11,6.41,11h7.43v2h-8c-.36,0-.68-.1899-.86-.5L1.14,16.5c-.1-.1499-.14-.3301-.14-.5s.04-.3501.14-.5L8.14,3.5c.18-.3101.5-.5.86-.5h14c.36,0,.68.1899.86.5l1.71,2.9299ZM19,11h-10v2h10v-2ZM17,15h-8v2h8v-2ZM15,19h-6v2h6v-2ZM26,11l-5,5,1.41,1.4099,2.59-2.5798v9.1699c0,1.6543-1.3457,3-3,3h-2v2h2c2.7568,0,5-2.2432,5-5v-9.1699l2.59,2.5798,1.41-1.4099-5-5Z"
  })), children);
})));
if (false) {}
const Code = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Code({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16 24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16 8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 15H26.080000000000002V17H5.91z",
    transform: "rotate(-75 15.996 16)"
  })), children);
})));
if (false) {}
const CodeHide = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CodeHide({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 13.471 19.576 6.518 17.645 6 16.08 11.838 17.713 13.471z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M24.207 19.965 25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.586 3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
  })), children);
})));
if (false) {}
const CodeReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CodeReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10 24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
    transform: "rotate(-74.995 16.96 10)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10 10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
  })), children);
})));
if (false) {}
const CodeBlock = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CodeBlock({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 3H10V5H2z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M6 9H30V11H6z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M6 15H30V17H6z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 27H10V29H2z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M6 21H22V23H6z"
  })), children);
})));
if (false) {}




/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 9365:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ OrbitControls; }
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4250);


/**
 * Fires when the camera has been transformed by the controls.
 *
 * @event OrbitControls#change
 * @type {Object}
 */
const _changeEvent = { type: 'change' };

/**
 * Fires when an interaction was initiated.
 *
 * @event OrbitControls#start
 * @type {Object}
 */
const _startEvent = { type: 'start' };

/**
 * Fires when an interaction has finished.
 *
 * @event OrbitControls#end
 * @type {Object}
 */
const _endEvent = { type: 'end' };

const _ray = new three__WEBPACK_IMPORTED_MODULE_0__/* .Ray */ .zHn();
const _plane = new three__WEBPACK_IMPORTED_MODULE_0__/* .Plane */ .JOQ();
const _TILT_LIMIT = Math.cos( 70 * three__WEBPACK_IMPORTED_MODULE_0__/* .MathUtils.DEG2RAD */ .M8C.DEG2RAD );

const _v = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
const _twoPI = 2 * Math.PI;

const _STATE = {
	NONE: - 1,
	ROTATE: 0,
	DOLLY: 1,
	PAN: 2,
	TOUCH_ROTATE: 3,
	TOUCH_PAN: 4,
	TOUCH_DOLLY_PAN: 5,
	TOUCH_DOLLY_ROTATE: 6
};
const _EPS = 0.000001;


/**
 * Orbit controls allow the camera to orbit around a target.
 *
 * OrbitControls performs orbiting, dollying (zooming), and panning. Unlike {@link TrackballControls},
 * it maintains the "up" direction `object.up` (+Y by default).
 *
 * - Orbit: Left mouse / touch: one-finger move.
 * - Zoom: Middle mouse, or mousewheel / touch: two-finger spread or squish.
 * - Pan: Right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move.
 *
 * ```js
 * const controls = new OrbitControls( camera, renderer.domElement );
 *
 * // controls.update() must be called after any manual changes to the camera's transform
 * camera.position.set( 0, 20, 100 );
 * controls.update();
 *
 * function animate() {
 *
 * 	// required if controls.enableDamping or controls.autoRotate are set to true
 * 	controls.update();
 *
 * 	renderer.render( scene, camera );
 *
 * }
 * ```
 *
 * @augments Controls
 * @three_import import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
 */
class OrbitControls extends three__WEBPACK_IMPORTED_MODULE_0__/* .Controls */ .ZXd {

	/**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */
	constructor( object, domElement = null ) {

		super( object, domElement );

		this.state = _STATE.NONE;

		/**
		 * The focus point of the controls, the `object` orbits around this.
		 * It can be updated manually at any point to change the focus of the controls.
		 *
		 * @type {Vector3}
		 */
		this.target = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

		/**
		 * The focus point of the `minTargetRadius` and `maxTargetRadius` limits.
		 * It can be updated manually at any point to change the center of interest
		 * for the `target`.
		 *
		 * @type {Vector3}
		 */
		this.cursor = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

		/**
		 * How far you can dolly in (perspective camera only).
		 *
		 * @type {number}
		 * @default 0
		 */
		this.minDistance = 0;

		/**
		 * How far you can dolly out (perspective camera only).
		 *
		 * @type {number}
		 * @default Infinity
		 */
		this.maxDistance = Infinity;

		/**
		 * How far you can zoom in (orthographic camera only).
		 *
		 * @type {number}
		 * @default 0
		 */
		this.minZoom = 0;

		/**
		 * How far you can zoom out (orthographic camera only).
		 *
		 * @type {number}
		 * @default Infinity
		 */
		this.maxZoom = Infinity;

		/**
		 * How close you can get the target to the 3D `cursor`.
		 *
		 * @type {number}
		 * @default 0
		 */
		this.minTargetRadius = 0;

		/**
		 * How far you can move the target from the 3D `cursor`.
		 *
		 * @type {number}
		 * @default Infinity
		 */
		this.maxTargetRadius = Infinity;

		/**
		 * How far you can orbit vertically, lower limit. Range is `[0, Math.PI]` radians.
		 *
		 * @type {number}
		 * @default 0
		 */
		this.minPolarAngle = 0;

		/**
		 * How far you can orbit vertically, upper limit. Range is `[0, Math.PI]` radians.
		 *
		 * @type {number}
		 * @default Math.PI
		 */
		this.maxPolarAngle = Math.PI;

		/**
		 * How far you can orbit horizontally, lower limit. If set, the interval `[ min, max ]`
		 * must be a sub-interval of `[ - 2 PI, 2 PI ]`, with `( max - min < 2 PI )`.
		 *
		 * @type {number}
		 * @default -Infinity
		 */
		this.minAzimuthAngle = - Infinity;

		/**
		 * How far you can orbit horizontally, upper limit. If set, the interval `[ min, max ]`
		 * must be a sub-interval of `[ - 2 PI, 2 PI ]`, with `( max - min < 2 PI )`.
		 *
		 * @type {number}
		 * @default -Infinity
		 */
		this.maxAzimuthAngle = Infinity;

		/**
		 * Set to `true` to enable damping (inertia), which can be used to give a sense of weight
		 * to the controls. Note that if this is enabled, you must call `update()` in your animation
		 * loop.
		 *
		 * @type {boolean}
		 * @default false
		 */
		this.enableDamping = false;

		/**
		 * The damping inertia used if `enableDamping` is set to `true`.
		 *
		 * Note that for this to work, you must call `update()` in your animation loop.
		 *
		 * @type {number}
		 * @default 0.05
		 */
		this.dampingFactor = 0.05;

		/**
		 * Enable or disable zooming (dollying) of the camera.
		 *
		 * @type {boolean}
		 * @default true
		 */
		this.enableZoom = true;

		/**
		 * Speed of zooming / dollying.
		 *
		 * @type {number}
		 * @default 1
		 */
		this.zoomSpeed = 1.0;

		/**
		 * Enable or disable horizontal and vertical rotation of the camera.
		 *
		 * Note that it is possible to disable a single axis by setting the min and max of the
		 * `minPolarAngle` or `minAzimuthAngle` to the same value, which will cause the vertical
		 * or horizontal rotation to be fixed at that value.
		 *
		 * @type {boolean}
		 * @default true
		 */
		this.enableRotate = true;

		/**
		 * Speed of rotation.
		 *
		 * @type {number}
		 * @default 1
		 */
		this.rotateSpeed = 1.0;

		/**
		 * How fast to rotate the camera when the keyboard is used.
		 *
		 * @type {number}
		 * @default 1
		 */
		this.keyRotateSpeed = 1.0;

		/**
		 * Enable or disable camera panning.
		 *
		 * @type {boolean}
		 * @default true
		 */
		this.enablePan = true;

		/**
		 * Speed of panning.
		 *
		 * @type {number}
		 * @default 1
		 */
		this.panSpeed = 1.0;

		/**
		 * Defines how the camera's position is translated when panning. If `true`, the camera pans
		 * in screen space. Otherwise, the camera pans in the plane orthogonal to the camera's up
		 * direction.
		 *
		 * @type {boolean}
		 * @default true
		 */
		this.screenSpacePanning = true;

		/**
		 * How fast to pan the camera when the keyboard is used in
		 * pixels per keypress.
		 *
		 * @type {number}
		 * @default 7
		 */
		this.keyPanSpeed = 7.0;

		/**
		 * Setting this property to `true` allows to zoom to the cursor's position.
		 *
		 * @type {boolean}
		 * @default false
		 */
		this.zoomToCursor = false;

		/**
		 * Set to true to automatically rotate around the target
		 *
		 * Note that if this is enabled, you must call `update()` in your animation loop.
		 * If you want the auto-rotate speed to be independent of the frame rate (the refresh
		 * rate of the display), you must pass the time `deltaTime`, in seconds, to `update()`.
		 *
		 * @type {boolean}
		 * @default false
		 */
		this.autoRotate = false;

		/**
		 * How fast to rotate around the target if `autoRotate` is `true`. The default  equates to 30 seconds
		 * per orbit at 60fps.
		 *
		 * Note that if `autoRotate` is enabled, you must call `update()` in your animation loop.
		 *
		 * @type {number}
		 * @default 2
		 */
		this.autoRotateSpeed = 2.0;

		/**
		 * This object contains references to the keycodes for controlling camera panning.
		 *
		 * ```js
		 * controls.keys = {
		 * 	LEFT: 'ArrowLeft', //left arrow
		 * 	UP: 'ArrowUp', // up arrow
		 * 	RIGHT: 'ArrowRight', // right arrow
		 * 	BOTTOM: 'ArrowDown' // down arrow
		 * }
		 * ```
		 * @type {Object}
		 */
		this.keys = { LEFT: 'ArrowLeft', UP: 'ArrowUp', RIGHT: 'ArrowRight', BOTTOM: 'ArrowDown' };

		/**
		 * This object contains references to the mouse actions used by the controls.
		 *
		 * ```js
		 * controls.mouseButtons = {
		 * 	LEFT: THREE.MOUSE.ROTATE,
		 * 	MIDDLE: THREE.MOUSE.DOLLY,
		 * 	RIGHT: THREE.MOUSE.PAN
		 * }
		 * ```
		 * @type {Object}
		 */
		this.mouseButtons = { LEFT: three__WEBPACK_IMPORTED_MODULE_0__/* .MOUSE.ROTATE */ .RsA.ROTATE, MIDDLE: three__WEBPACK_IMPORTED_MODULE_0__/* .MOUSE.DOLLY */ .RsA.DOLLY, RIGHT: three__WEBPACK_IMPORTED_MODULE_0__/* .MOUSE.PAN */ .RsA.PAN };

		/**
		 * This object contains references to the touch actions used by the controls.
		 *
		 * ```js
		 * controls.mouseButtons = {
		 * 	ONE: THREE.TOUCH.ROTATE,
		 * 	TWO: THREE.TOUCH.DOLLY_PAN
		 * }
		 * ```
		 * @type {Object}
		 */
		this.touches = { ONE: three__WEBPACK_IMPORTED_MODULE_0__/* .TOUCH.ROTATE */ .QmN.ROTATE, TWO: three__WEBPACK_IMPORTED_MODULE_0__/* .TOUCH.DOLLY_PAN */ .QmN.DOLLY_PAN };

		/**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {Vector3}
		 */
		this.target0 = this.target.clone();

		/**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {Vector3}
		 */
		this.position0 = this.object.position.clone();

		/**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {number}
		 */
		this.zoom0 = this.object.zoom;

		// the target DOM element for key events
		this._domElementKeyEvents = null;

		// internals

		this._lastPosition = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
		this._lastQuaternion = new three__WEBPACK_IMPORTED_MODULE_0__/* .Quaternion */ ._fP();
		this._lastTargetPosition = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

		// so camera.up is the orbit axis
		this._quat = new three__WEBPACK_IMPORTED_MODULE_0__/* .Quaternion */ ._fP().setFromUnitVectors( object.up, new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4( 0, 1, 0 ) );
		this._quatInverse = this._quat.clone().invert();

		// current position in spherical coordinates
		this._spherical = new three__WEBPACK_IMPORTED_MODULE_0__/* .Spherical */ .$V();
		this._sphericalDelta = new three__WEBPACK_IMPORTED_MODULE_0__/* .Spherical */ .$V();

		this._scale = 1;
		this._panOffset = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();

		this._rotateStart = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
		this._rotateEnd = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
		this._rotateDelta = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();

		this._panStart = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
		this._panEnd = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
		this._panDelta = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();

		this._dollyStart = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
		this._dollyEnd = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
		this._dollyDelta = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();

		this._dollyDirection = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
		this._mouse = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
		this._performCursorZoom = false;

		this._pointers = [];
		this._pointerPositions = {};

		this._controlActive = false;

		// event listeners

		this._onPointerMove = onPointerMove.bind( this );
		this._onPointerDown = onPointerDown.bind( this );
		this._onPointerUp = onPointerUp.bind( this );
		this._onContextMenu = onContextMenu.bind( this );
		this._onMouseWheel = onMouseWheel.bind( this );
		this._onKeyDown = onKeyDown.bind( this );

		this._onTouchStart = onTouchStart.bind( this );
		this._onTouchMove = onTouchMove.bind( this );

		this._onMouseDown = onMouseDown.bind( this );
		this._onMouseMove = onMouseMove.bind( this );

		this._interceptControlDown = interceptControlDown.bind( this );
		this._interceptControlUp = interceptControlUp.bind( this );

		//

		if ( this.domElement !== null ) {

			this.connect( this.domElement );

		}

		this.update();

	}

	connect( element ) {

		super.connect( element );

		this.domElement.addEventListener( 'pointerdown', this._onPointerDown );
		this.domElement.addEventListener( 'pointercancel', this._onPointerUp );

		this.domElement.addEventListener( 'contextmenu', this._onContextMenu );
		this.domElement.addEventListener( 'wheel', this._onMouseWheel, { passive: false } );

		const document = this.domElement.getRootNode(); // offscreen canvas compatibility
		document.addEventListener( 'keydown', this._interceptControlDown, { passive: true, capture: true } );

		this.domElement.style.touchAction = 'none'; // disable touch scroll

	}

	disconnect() {

		this.domElement.removeEventListener( 'pointerdown', this._onPointerDown );
		this.domElement.ownerDocument.removeEventListener( 'pointermove', this._onPointerMove );
		this.domElement.ownerDocument.removeEventListener( 'pointerup', this._onPointerUp );
		this.domElement.removeEventListener( 'pointercancel', this._onPointerUp );

		this.domElement.removeEventListener( 'wheel', this._onMouseWheel );
		this.domElement.removeEventListener( 'contextmenu', this._onContextMenu );

		this.stopListenToKeyEvents();

		const document = this.domElement.getRootNode(); // offscreen canvas compatibility
		document.removeEventListener( 'keydown', this._interceptControlDown, { capture: true } );

		this.domElement.style.touchAction = 'auto';

	}

	dispose() {

		this.disconnect();

	}

	/**
	 * Get the current vertical rotation, in radians.
	 *
	 * @return {number} The current vertical rotation, in radians.
	 */
	getPolarAngle() {

		return this._spherical.phi;

	}

	/**
	 * Get the current horizontal rotation, in radians.
	 *
	 * @return {number} The current horizontal rotation, in radians.
	 */
	getAzimuthalAngle() {

		return this._spherical.theta;

	}

	/**
	 * Returns the distance from the camera to the target.
	 *
	 * @return {number} The distance from the camera to the target.
	 */
	getDistance() {

		return this.object.position.distanceTo( this.target );

	}

	/**
	 * Adds key event listeners to the given DOM element.
	 * `window` is a recommended argument for using this method.
	 *
	 * @param {HTMLElement} domElement - The DOM element
	 */
	listenToKeyEvents( domElement ) {

		domElement.addEventListener( 'keydown', this._onKeyDown );
		this._domElementKeyEvents = domElement;

	}

	/**
	 * Removes the key event listener previously defined with `listenToKeyEvents()`.
	 */
	stopListenToKeyEvents() {

		if ( this._domElementKeyEvents !== null ) {

			this._domElementKeyEvents.removeEventListener( 'keydown', this._onKeyDown );
			this._domElementKeyEvents = null;

		}

	}

	/**
	 * Save the current state of the controls. This can later be recovered with `reset()`.
	 */
	saveState() {

		this.target0.copy( this.target );
		this.position0.copy( this.object.position );
		this.zoom0 = this.object.zoom;

	}

	/**
	 * Reset the controls to their state from either the last time the `saveState()`
	 * was called, or the initial state.
	 */
	reset() {

		this.target.copy( this.target0 );
		this.object.position.copy( this.position0 );
		this.object.zoom = this.zoom0;

		this.object.updateProjectionMatrix();
		this.dispatchEvent( _changeEvent );

		this.update();

		this.state = _STATE.NONE;

	}

	update( deltaTime = null ) {

		const position = this.object.position;

		_v.copy( position ).sub( this.target );

		// rotate offset to "y-axis-is-up" space
		_v.applyQuaternion( this._quat );

		// angle from z-axis around y-axis
		this._spherical.setFromVector3( _v );

		if ( this.autoRotate && this.state === _STATE.NONE ) {

			this._rotateLeft( this._getAutoRotationAngle( deltaTime ) );

		}

		if ( this.enableDamping ) {

			this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
			this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;

		} else {

			this._spherical.theta += this._sphericalDelta.theta;
			this._spherical.phi += this._sphericalDelta.phi;

		}

		// restrict theta to be between desired limits

		let min = this.minAzimuthAngle;
		let max = this.maxAzimuthAngle;

		if ( isFinite( min ) && isFinite( max ) ) {

			if ( min < - Math.PI ) min += _twoPI; else if ( min > Math.PI ) min -= _twoPI;

			if ( max < - Math.PI ) max += _twoPI; else if ( max > Math.PI ) max -= _twoPI;

			if ( min <= max ) {

				this._spherical.theta = Math.max( min, Math.min( max, this._spherical.theta ) );

			} else {

				this._spherical.theta = ( this._spherical.theta > ( min + max ) / 2 ) ?
					Math.max( min, this._spherical.theta ) :
					Math.min( max, this._spherical.theta );

			}

		}

		// restrict phi to be between desired limits
		this._spherical.phi = Math.max( this.minPolarAngle, Math.min( this.maxPolarAngle, this._spherical.phi ) );

		this._spherical.makeSafe();


		// move target to panned location

		if ( this.enableDamping === true ) {

			this.target.addScaledVector( this._panOffset, this.dampingFactor );

		} else {

			this.target.add( this._panOffset );

		}

		// Limit the target distance from the cursor to create a sphere around the center of interest
		this.target.sub( this.cursor );
		this.target.clampLength( this.minTargetRadius, this.maxTargetRadius );
		this.target.add( this.cursor );

		let zoomChanged = false;
		// adjust the camera position based on zoom only if we're not zooming to the cursor or if it's an ortho camera
		// we adjust zoom later in these cases
		if ( this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera ) {

			this._spherical.radius = this._clampDistance( this._spherical.radius );

		} else {

			const prevRadius = this._spherical.radius;
			this._spherical.radius = this._clampDistance( this._spherical.radius * this._scale );
			zoomChanged = prevRadius != this._spherical.radius;

		}

		_v.setFromSpherical( this._spherical );

		// rotate offset back to "camera-up-vector-is-up" space
		_v.applyQuaternion( this._quatInverse );

		position.copy( this.target ).add( _v );

		this.object.lookAt( this.target );

		if ( this.enableDamping === true ) {

			this._sphericalDelta.theta *= ( 1 - this.dampingFactor );
			this._sphericalDelta.phi *= ( 1 - this.dampingFactor );

			this._panOffset.multiplyScalar( 1 - this.dampingFactor );

		} else {

			this._sphericalDelta.set( 0, 0, 0 );

			this._panOffset.set( 0, 0, 0 );

		}

		// adjust camera position
		if ( this.zoomToCursor && this._performCursorZoom ) {

			let newRadius = null;
			if ( this.object.isPerspectiveCamera ) {

				// move the camera down the pointer ray
				// this method avoids floating point error
				const prevRadius = _v.length();
				newRadius = this._clampDistance( prevRadius * this._scale );

				const radiusDelta = prevRadius - newRadius;
				this.object.position.addScaledVector( this._dollyDirection, radiusDelta );
				this.object.updateMatrixWorld();

				zoomChanged = !! radiusDelta;

			} else if ( this.object.isOrthographicCamera ) {

				// adjust the ortho camera position based on zoom changes
				const mouseBefore = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4( this._mouse.x, this._mouse.y, 0 );
				mouseBefore.unproject( this.object );

				const prevZoom = this.object.zoom;
				this.object.zoom = Math.max( this.minZoom, Math.min( this.maxZoom, this.object.zoom / this._scale ) );
				this.object.updateProjectionMatrix();

				zoomChanged = prevZoom !== this.object.zoom;

				const mouseAfter = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4( this._mouse.x, this._mouse.y, 0 );
				mouseAfter.unproject( this.object );

				this.object.position.sub( mouseAfter ).add( mouseBefore );
				this.object.updateMatrixWorld();

				newRadius = _v.length();

			} else {

				console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.' );
				this.zoomToCursor = false;

			}

			// handle the placement of the target
			if ( newRadius !== null ) {

				if ( this.screenSpacePanning ) {

					// position the orbit target in front of the new camera position
					this.target.set( 0, 0, - 1 )
						.transformDirection( this.object.matrix )
						.multiplyScalar( newRadius )
						.add( this.object.position );

				} else {

					// get the ray and translation plane to compute target
					_ray.origin.copy( this.object.position );
					_ray.direction.set( 0, 0, - 1 ).transformDirection( this.object.matrix );

					// if the camera is 20 degrees above the horizon then don't adjust the focus target to avoid
					// extremely large values
					if ( Math.abs( this.object.up.dot( _ray.direction ) ) < _TILT_LIMIT ) {

						this.object.lookAt( this.target );

					} else {

						_plane.setFromNormalAndCoplanarPoint( this.object.up, this.target );
						_ray.intersectPlane( _plane, this.target );

					}

				}

			}

		} else if ( this.object.isOrthographicCamera ) {

			const prevZoom = this.object.zoom;
			this.object.zoom = Math.max( this.minZoom, Math.min( this.maxZoom, this.object.zoom / this._scale ) );

			if ( prevZoom !== this.object.zoom ) {

				this.object.updateProjectionMatrix();
				zoomChanged = true;

			}

		}

		this._scale = 1;
		this._performCursorZoom = false;

		// update condition is:
		// min(camera displacement, camera rotation in radians)^2 > EPS
		// using small-angle approximation cos(x/2) = 1 - x^2 / 8

		if ( zoomChanged ||
			this._lastPosition.distanceToSquared( this.object.position ) > _EPS ||
			8 * ( 1 - this._lastQuaternion.dot( this.object.quaternion ) ) > _EPS ||
			this._lastTargetPosition.distanceToSquared( this.target ) > _EPS ) {

			this.dispatchEvent( _changeEvent );

			this._lastPosition.copy( this.object.position );
			this._lastQuaternion.copy( this.object.quaternion );
			this._lastTargetPosition.copy( this.target );

			return true;

		}

		return false;

	}

	_getAutoRotationAngle( deltaTime ) {

		if ( deltaTime !== null ) {

			return ( _twoPI / 60 * this.autoRotateSpeed ) * deltaTime;

		} else {

			return _twoPI / 60 / 60 * this.autoRotateSpeed;

		}

	}

	_getZoomScale( delta ) {

		const normalizedDelta = Math.abs( delta * 0.01 );
		return Math.pow( 0.95, this.zoomSpeed * normalizedDelta );

	}

	_rotateLeft( angle ) {

		this._sphericalDelta.theta -= angle;

	}

	_rotateUp( angle ) {

		this._sphericalDelta.phi -= angle;

	}

	_panLeft( distance, objectMatrix ) {

		_v.setFromMatrixColumn( objectMatrix, 0 ); // get X column of objectMatrix
		_v.multiplyScalar( - distance );

		this._panOffset.add( _v );

	}

	_panUp( distance, objectMatrix ) {

		if ( this.screenSpacePanning === true ) {

			_v.setFromMatrixColumn( objectMatrix, 1 );

		} else {

			_v.setFromMatrixColumn( objectMatrix, 0 );
			_v.crossVectors( this.object.up, _v );

		}

		_v.multiplyScalar( distance );

		this._panOffset.add( _v );

	}

	// deltaX and deltaY are in pixels; right and down are positive
	_pan( deltaX, deltaY ) {

		const element = this.domElement;

		if ( this.object.isPerspectiveCamera ) {

			// perspective
			const position = this.object.position;
			_v.copy( position ).sub( this.target );
			let targetDistance = _v.length();

			// half of the fov is center to top of screen
			targetDistance *= Math.tan( ( this.object.fov / 2 ) * Math.PI / 180.0 );

			// we use only clientHeight here so aspect ratio does not distort speed
			this._panLeft( 2 * deltaX * targetDistance / element.clientHeight, this.object.matrix );
			this._panUp( 2 * deltaY * targetDistance / element.clientHeight, this.object.matrix );

		} else if ( this.object.isOrthographicCamera ) {

			// orthographic
			this._panLeft( deltaX * ( this.object.right - this.object.left ) / this.object.zoom / element.clientWidth, this.object.matrix );
			this._panUp( deltaY * ( this.object.top - this.object.bottom ) / this.object.zoom / element.clientHeight, this.object.matrix );

		} else {

			// camera neither orthographic nor perspective
			console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.' );
			this.enablePan = false;

		}

	}

	_dollyOut( dollyScale ) {

		if ( this.object.isPerspectiveCamera || this.object.isOrthographicCamera ) {

			this._scale /= dollyScale;

		} else {

			console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.' );
			this.enableZoom = false;

		}

	}

	_dollyIn( dollyScale ) {

		if ( this.object.isPerspectiveCamera || this.object.isOrthographicCamera ) {

			this._scale *= dollyScale;

		} else {

			console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.' );
			this.enableZoom = false;

		}

	}

	_updateZoomParameters( x, y ) {

		if ( ! this.zoomToCursor ) {

			return;

		}

		this._performCursorZoom = true;

		const rect = this.domElement.getBoundingClientRect();
		const dx = x - rect.left;
		const dy = y - rect.top;
		const w = rect.width;
		const h = rect.height;

		this._mouse.x = ( dx / w ) * 2 - 1;
		this._mouse.y = - ( dy / h ) * 2 + 1;

		this._dollyDirection.set( this._mouse.x, this._mouse.y, 1 ).unproject( this.object ).sub( this.object.position ).normalize();

	}

	_clampDistance( dist ) {

		return Math.max( this.minDistance, Math.min( this.maxDistance, dist ) );

	}

	//
	// event callbacks - update the object state
	//

	_handleMouseDownRotate( event ) {

		this._rotateStart.set( event.clientX, event.clientY );

	}

	_handleMouseDownDolly( event ) {

		this._updateZoomParameters( event.clientX, event.clientX );
		this._dollyStart.set( event.clientX, event.clientY );

	}

	_handleMouseDownPan( event ) {

		this._panStart.set( event.clientX, event.clientY );

	}

	_handleMouseMoveRotate( event ) {

		this._rotateEnd.set( event.clientX, event.clientY );

		this._rotateDelta.subVectors( this._rotateEnd, this._rotateStart ).multiplyScalar( this.rotateSpeed );

		const element = this.domElement;

		this._rotateLeft( _twoPI * this._rotateDelta.x / element.clientHeight ); // yes, height

		this._rotateUp( _twoPI * this._rotateDelta.y / element.clientHeight );

		this._rotateStart.copy( this._rotateEnd );

		this.update();

	}

	_handleMouseMoveDolly( event ) {

		this._dollyEnd.set( event.clientX, event.clientY );

		this._dollyDelta.subVectors( this._dollyEnd, this._dollyStart );

		if ( this._dollyDelta.y > 0 ) {

			this._dollyOut( this._getZoomScale( this._dollyDelta.y ) );

		} else if ( this._dollyDelta.y < 0 ) {

			this._dollyIn( this._getZoomScale( this._dollyDelta.y ) );

		}

		this._dollyStart.copy( this._dollyEnd );

		this.update();

	}

	_handleMouseMovePan( event ) {

		this._panEnd.set( event.clientX, event.clientY );

		this._panDelta.subVectors( this._panEnd, this._panStart ).multiplyScalar( this.panSpeed );

		this._pan( this._panDelta.x, this._panDelta.y );

		this._panStart.copy( this._panEnd );

		this.update();

	}

	_handleMouseWheel( event ) {

		this._updateZoomParameters( event.clientX, event.clientY );

		if ( event.deltaY < 0 ) {

			this._dollyIn( this._getZoomScale( event.deltaY ) );

		} else if ( event.deltaY > 0 ) {

			this._dollyOut( this._getZoomScale( event.deltaY ) );

		}

		this.update();

	}

	_handleKeyDown( event ) {

		let needsUpdate = false;

		switch ( event.code ) {

			case this.keys.UP:

				if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

					if ( this.enableRotate ) {

						this._rotateUp( _twoPI * this.keyRotateSpeed / this.domElement.clientHeight );

					}

				} else {

					if ( this.enablePan ) {

						this._pan( 0, this.keyPanSpeed );

					}

				}

				needsUpdate = true;
				break;

			case this.keys.BOTTOM:

				if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

					if ( this.enableRotate ) {

						this._rotateUp( - _twoPI * this.keyRotateSpeed / this.domElement.clientHeight );

					}

				} else {

					if ( this.enablePan ) {

						this._pan( 0, - this.keyPanSpeed );

					}

				}

				needsUpdate = true;
				break;

			case this.keys.LEFT:

				if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

					if ( this.enableRotate ) {

						this._rotateLeft( _twoPI * this.keyRotateSpeed / this.domElement.clientHeight );

					}

				} else {

					if ( this.enablePan ) {

						this._pan( this.keyPanSpeed, 0 );

					}

				}

				needsUpdate = true;
				break;

			case this.keys.RIGHT:

				if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

					if ( this.enableRotate ) {

						this._rotateLeft( - _twoPI * this.keyRotateSpeed / this.domElement.clientHeight );

					}

				} else {

					if ( this.enablePan ) {

						this._pan( - this.keyPanSpeed, 0 );

					}

				}

				needsUpdate = true;
				break;

		}

		if ( needsUpdate ) {

			// prevent the browser from scrolling on cursor keys
			event.preventDefault();

			this.update();

		}


	}

	_handleTouchStartRotate( event ) {

		if ( this._pointers.length === 1 ) {

			this._rotateStart.set( event.pageX, event.pageY );

		} else {

			const position = this._getSecondPointerPosition( event );

			const x = 0.5 * ( event.pageX + position.x );
			const y = 0.5 * ( event.pageY + position.y );

			this._rotateStart.set( x, y );

		}

	}

	_handleTouchStartPan( event ) {

		if ( this._pointers.length === 1 ) {

			this._panStart.set( event.pageX, event.pageY );

		} else {

			const position = this._getSecondPointerPosition( event );

			const x = 0.5 * ( event.pageX + position.x );
			const y = 0.5 * ( event.pageY + position.y );

			this._panStart.set( x, y );

		}

	}

	_handleTouchStartDolly( event ) {

		const position = this._getSecondPointerPosition( event );

		const dx = event.pageX - position.x;
		const dy = event.pageY - position.y;

		const distance = Math.sqrt( dx * dx + dy * dy );

		this._dollyStart.set( 0, distance );

	}

	_handleTouchStartDollyPan( event ) {

		if ( this.enableZoom ) this._handleTouchStartDolly( event );

		if ( this.enablePan ) this._handleTouchStartPan( event );

	}

	_handleTouchStartDollyRotate( event ) {

		if ( this.enableZoom ) this._handleTouchStartDolly( event );

		if ( this.enableRotate ) this._handleTouchStartRotate( event );

	}

	_handleTouchMoveRotate( event ) {

		if ( this._pointers.length == 1 ) {

			this._rotateEnd.set( event.pageX, event.pageY );

		} else {

			const position = this._getSecondPointerPosition( event );

			const x = 0.5 * ( event.pageX + position.x );
			const y = 0.5 * ( event.pageY + position.y );

			this._rotateEnd.set( x, y );

		}

		this._rotateDelta.subVectors( this._rotateEnd, this._rotateStart ).multiplyScalar( this.rotateSpeed );

		const element = this.domElement;

		this._rotateLeft( _twoPI * this._rotateDelta.x / element.clientHeight ); // yes, height

		this._rotateUp( _twoPI * this._rotateDelta.y / element.clientHeight );

		this._rotateStart.copy( this._rotateEnd );

	}

	_handleTouchMovePan( event ) {

		if ( this._pointers.length === 1 ) {

			this._panEnd.set( event.pageX, event.pageY );

		} else {

			const position = this._getSecondPointerPosition( event );

			const x = 0.5 * ( event.pageX + position.x );
			const y = 0.5 * ( event.pageY + position.y );

			this._panEnd.set( x, y );

		}

		this._panDelta.subVectors( this._panEnd, this._panStart ).multiplyScalar( this.panSpeed );

		this._pan( this._panDelta.x, this._panDelta.y );

		this._panStart.copy( this._panEnd );

	}

	_handleTouchMoveDolly( event ) {

		const position = this._getSecondPointerPosition( event );

		const dx = event.pageX - position.x;
		const dy = event.pageY - position.y;

		const distance = Math.sqrt( dx * dx + dy * dy );

		this._dollyEnd.set( 0, distance );

		this._dollyDelta.set( 0, Math.pow( this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed ) );

		this._dollyOut( this._dollyDelta.y );

		this._dollyStart.copy( this._dollyEnd );

		const centerX = ( event.pageX + position.x ) * 0.5;
		const centerY = ( event.pageY + position.y ) * 0.5;

		this._updateZoomParameters( centerX, centerY );

	}

	_handleTouchMoveDollyPan( event ) {

		if ( this.enableZoom ) this._handleTouchMoveDolly( event );

		if ( this.enablePan ) this._handleTouchMovePan( event );

	}

	_handleTouchMoveDollyRotate( event ) {

		if ( this.enableZoom ) this._handleTouchMoveDolly( event );

		if ( this.enableRotate ) this._handleTouchMoveRotate( event );

	}

	// pointers

	_addPointer( event ) {

		this._pointers.push( event.pointerId );

	}

	_removePointer( event ) {

		delete this._pointerPositions[ event.pointerId ];

		for ( let i = 0; i < this._pointers.length; i ++ ) {

			if ( this._pointers[ i ] == event.pointerId ) {

				this._pointers.splice( i, 1 );
				return;

			}

		}

	}

	_isTrackingPointer( event ) {

		for ( let i = 0; i < this._pointers.length; i ++ ) {

			if ( this._pointers[ i ] == event.pointerId ) return true;

		}

		return false;

	}

	_trackPointer( event ) {

		let position = this._pointerPositions[ event.pointerId ];

		if ( position === undefined ) {

			position = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
			this._pointerPositions[ event.pointerId ] = position;

		}

		position.set( event.pageX, event.pageY );

	}

	_getSecondPointerPosition( event ) {

		const pointerId = ( event.pointerId === this._pointers[ 0 ] ) ? this._pointers[ 1 ] : this._pointers[ 0 ];

		return this._pointerPositions[ pointerId ];

	}

	//

	_customWheelEvent( event ) {

		const mode = event.deltaMode;

		// minimal wheel event altered to meet delta-zoom demand
		const newEvent = {
			clientX: event.clientX,
			clientY: event.clientY,
			deltaY: event.deltaY,
		};

		switch ( mode ) {

			case 1: // LINE_MODE
				newEvent.deltaY *= 16;
				break;

			case 2: // PAGE_MODE
				newEvent.deltaY *= 100;
				break;

		}

		// detect if event was triggered by pinching
		if ( event.ctrlKey && ! this._controlActive ) {

			newEvent.deltaY *= 10;

		}

		return newEvent;

	}

}

function onPointerDown( event ) {

	if ( this.enabled === false ) return;

	if ( this._pointers.length === 0 ) {

		this.domElement.setPointerCapture( event.pointerId );

		this.domElement.ownerDocument.addEventListener( 'pointermove', this._onPointerMove );
		this.domElement.ownerDocument.addEventListener( 'pointerup', this._onPointerUp );

	}

	//

	if ( this._isTrackingPointer( event ) ) return;

	//

	this._addPointer( event );

	if ( event.pointerType === 'touch' ) {

		this._onTouchStart( event );

	} else {

		this._onMouseDown( event );

	}

}

function onPointerMove( event ) {

	if ( this.enabled === false ) return;

	if ( event.pointerType === 'touch' ) {

		this._onTouchMove( event );

	} else {

		this._onMouseMove( event );

	}

}

function onPointerUp( event ) {

	this._removePointer( event );

	switch ( this._pointers.length ) {

		case 0:

			this.domElement.releasePointerCapture( event.pointerId );

			this.domElement.ownerDocument.removeEventListener( 'pointermove', this._onPointerMove );
			this.domElement.ownerDocument.removeEventListener( 'pointerup', this._onPointerUp );

			this.dispatchEvent( _endEvent );

			this.state = _STATE.NONE;

			break;

		case 1:

			const pointerId = this._pointers[ 0 ];
			const position = this._pointerPositions[ pointerId ];

			// minimal placeholder event - allows state correction on pointer-up
			this._onTouchStart( { pointerId: pointerId, pageX: position.x, pageY: position.y } );

			break;

	}

}

function onMouseDown( event ) {

	let mouseAction;

	switch ( event.button ) {

		case 0:

			mouseAction = this.mouseButtons.LEFT;
			break;

		case 1:

			mouseAction = this.mouseButtons.MIDDLE;
			break;

		case 2:

			mouseAction = this.mouseButtons.RIGHT;
			break;

		default:

			mouseAction = - 1;

	}

	switch ( mouseAction ) {

		case three__WEBPACK_IMPORTED_MODULE_0__/* .MOUSE.DOLLY */ .RsA.DOLLY:

			if ( this.enableZoom === false ) return;

			this._handleMouseDownDolly( event );

			this.state = _STATE.DOLLY;

			break;

		case three__WEBPACK_IMPORTED_MODULE_0__/* .MOUSE.ROTATE */ .RsA.ROTATE:

			if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

				if ( this.enablePan === false ) return;

				this._handleMouseDownPan( event );

				this.state = _STATE.PAN;

			} else {

				if ( this.enableRotate === false ) return;

				this._handleMouseDownRotate( event );

				this.state = _STATE.ROTATE;

			}

			break;

		case three__WEBPACK_IMPORTED_MODULE_0__/* .MOUSE.PAN */ .RsA.PAN:

			if ( event.ctrlKey || event.metaKey || event.shiftKey ) {

				if ( this.enableRotate === false ) return;

				this._handleMouseDownRotate( event );

				this.state = _STATE.ROTATE;

			} else {

				if ( this.enablePan === false ) return;

				this._handleMouseDownPan( event );

				this.state = _STATE.PAN;

			}

			break;

		default:

			this.state = _STATE.NONE;

	}

	if ( this.state !== _STATE.NONE ) {

		this.dispatchEvent( _startEvent );

	}

}

function onMouseMove( event ) {

	switch ( this.state ) {

		case _STATE.ROTATE:

			if ( this.enableRotate === false ) return;

			this._handleMouseMoveRotate( event );

			break;

		case _STATE.DOLLY:

			if ( this.enableZoom === false ) return;

			this._handleMouseMoveDolly( event );

			break;

		case _STATE.PAN:

			if ( this.enablePan === false ) return;

			this._handleMouseMovePan( event );

			break;

	}

}

function onMouseWheel( event ) {

	if ( this.enabled === false || this.enableZoom === false || this.state !== _STATE.NONE ) return;

	event.preventDefault();

	this.dispatchEvent( _startEvent );

	this._handleMouseWheel( this._customWheelEvent( event ) );

	this.dispatchEvent( _endEvent );

}

function onKeyDown( event ) {

	if ( this.enabled === false ) return;

	this._handleKeyDown( event );

}

function onTouchStart( event ) {

	this._trackPointer( event );

	switch ( this._pointers.length ) {

		case 1:

			switch ( this.touches.ONE ) {

				case three__WEBPACK_IMPORTED_MODULE_0__/* .TOUCH.ROTATE */ .QmN.ROTATE:

					if ( this.enableRotate === false ) return;

					this._handleTouchStartRotate( event );

					this.state = _STATE.TOUCH_ROTATE;

					break;

				case three__WEBPACK_IMPORTED_MODULE_0__/* .TOUCH.PAN */ .QmN.PAN:

					if ( this.enablePan === false ) return;

					this._handleTouchStartPan( event );

					this.state = _STATE.TOUCH_PAN;

					break;

				default:

					this.state = _STATE.NONE;

			}

			break;

		case 2:

			switch ( this.touches.TWO ) {

				case three__WEBPACK_IMPORTED_MODULE_0__/* .TOUCH.DOLLY_PAN */ .QmN.DOLLY_PAN:

					if ( this.enableZoom === false && this.enablePan === false ) return;

					this._handleTouchStartDollyPan( event );

					this.state = _STATE.TOUCH_DOLLY_PAN;

					break;

				case three__WEBPACK_IMPORTED_MODULE_0__/* .TOUCH.DOLLY_ROTATE */ .QmN.DOLLY_ROTATE:

					if ( this.enableZoom === false && this.enableRotate === false ) return;

					this._handleTouchStartDollyRotate( event );

					this.state = _STATE.TOUCH_DOLLY_ROTATE;

					break;

				default:

					this.state = _STATE.NONE;

			}

			break;

		default:

			this.state = _STATE.NONE;

	}

	if ( this.state !== _STATE.NONE ) {

		this.dispatchEvent( _startEvent );

	}

}

function onTouchMove( event ) {

	this._trackPointer( event );

	switch ( this.state ) {

		case _STATE.TOUCH_ROTATE:

			if ( this.enableRotate === false ) return;

			this._handleTouchMoveRotate( event );

			this.update();

			break;

		case _STATE.TOUCH_PAN:

			if ( this.enablePan === false ) return;

			this._handleTouchMovePan( event );

			this.update();

			break;

		case _STATE.TOUCH_DOLLY_PAN:

			if ( this.enableZoom === false && this.enablePan === false ) return;

			this._handleTouchMoveDollyPan( event );

			this.update();

			break;

		case _STATE.TOUCH_DOLLY_ROTATE:

			if ( this.enableZoom === false && this.enableRotate === false ) return;

			this._handleTouchMoveDollyRotate( event );

			this.update();

			break;

		default:

			this.state = _STATE.NONE;

	}

}

function onContextMenu( event ) {

	if ( this.enabled === false ) return;

	event.preventDefault();

}

function interceptControlDown( event ) {

	if ( event.key === 'Control' ) {

		this._controlActive = true;

		const document = this.domElement.getRootNode(); // offscreen canvas compatibility

		document.addEventListener( 'keyup', this._interceptControlUp, { passive: true, capture: true } );

	}

}

function interceptControlUp( event ) {

	if ( event.key === 'Control' ) {

		this._controlActive = false;

		const document = this.domElement.getRootNode(); // offscreen canvas compatibility

		document.removeEventListener( 'keyup', this._interceptControlUp, { passive: true, capture: true } );

	}

}




/***/ })

}]);